var prop_values = new Object();
var prop_name = new Object();
var cats_content = new Object();
var session_shop_type;
$(document).ready(function() {
    window.copy_goods = new copyGoods();
    copy_goods.init();
    //url切换tab
    tabActive();
});

//interval
var init_interval, showname_interval, moredata_interval, showshopmsg_interval;

function copyGoods() {
    this.copytaobao_list = [] //复制淘宝精品数组
    var that = this;
    var copyshop_list; //复制店铺数组
    var five_flag;
    var tab_type = 'one'; //记录当前的选项卡
    //复制升级层
    this.copyUpdate = function(str, num) {
        var update_config_json = JSON.parse(str);
        var max_btn = $("#copy-upgrade .max-upgrade-btn");
        var min_btn = $("#copy-upgrade .min-upgrade-btn");
        var max_html = "";
        var min_html = "";
        var yj_price = $("#copy-upgrade .yj-price");
        var cx_price = $("#copy-upgrade .cx-price");
        $("#copy-upgrade").attr('version_no', num);
        if (num > 5) {
            var modal = $("#copy-upgrade");
            modal.find('.modal-title').html('升级提示');
            var version;
            if (num == 6) {
                version = '黑钻版';
            } else if (num == 7) {
                version = '至尊版';
            } else if (num == 8) {
                version = '超级至尊版';
            }
            var html = "<div class=\"text-centers\" style='margin-top:20px;'>\n" +
                "<i class=\"gticon\"></i>\n" +
                "<span class=\"i-block middle\"  style='width: 400px;color:red;text-align: -moz-left;'>您在用的" + version + "已下线，更多复制数量已改为数量包订购。\n" +
                "若有需要，请订购其他版本或联系客服<a href=\"http://www.taobao.com/webww/ww.php?ver=3&touid=hyeo&siteid=cntaobao&status=1&charset=utf-8\" target=\"_blank\"><i class=\"contactme contactme-icon\"></i></a>获取帮助。</span>\n" +
                "</div>";
            modal.find('.modal-body').html(html);
            modal.find('.modal-footer').hide();
            return;
        }
        for (var i in update_config_json) {
            if (i > num) {
                //隐藏钻石版（5）以上版本  已订购的按原样显示
                if (num <= 5 && i > 5) {
                    continue;
                }
                var isx = update_config_json[i];
                switch (parseFloat(i)) {
                    case 2:
                        max_html += "<div class='m-btm-10'><a class='upgrade-btn'" + " data-sx='" + i + "' " + " data-price='" + isx.price + "'" + " href='javascript:;'>" + isx.name + "，每月可复制" + isx.month_limit + "个宝贝</a><span class='ub-last'>仅有复制+基础功能</span></div>";
                        break;
                    case 3:
                        max_html += "<div class='m-btm-10'><a class='upgrade-btn'" + " data-sx='" + i + "' " + " data-price='" + isx.price + "'" + " href='javascript:;'>" + isx.name + "，每月可复制" + isx.month_limit + "个宝贝<span class='tlabel-danger m-left-5'>荐</span></a><span class='ub-last'>包含基础+高级<a class='blue-underline' href='http://help.dzsofts.net/default.php?app_id=14#641' target='_blank'>全部功能</a></span></div>";
                        break;
                    default:
                        max_html += "<div class='m-btm-10'><a class='upgrade-btn'" + " data-sx='" + i + "' " + " data-price='" + isx.price + "'" + " href='javascript:;'>" + isx.name + "，每月可复制" + isx.month_limit + "个宝贝</a><span class='ub-last'>包含基础+高级<a class='blue-underline' href='http://help.dzsofts.net/default.php?app_id=14#641' target='_blank'>全部功能</a></span></div>";
                        break;
                }
            }
        }
        max_btn.html(max_html);

        max_btn.on("click", ".upgrade-btn", function() {
            var json_obj = JSON.parse(str);
            var that = $(this);
            var html = "";
            var minbn = null;
            that.closest("div").siblings("div").each(function() {
                $(this).children(".upgrade-btn").removeClass("active");
            });
            that.addClass("active");
            copy_goods.updateActive(str);
        });
        max_btn.find(".upgrade-btn").eq(0).trigger("click");
        min_btn.on("click", ".upgrade-btn", function() {
            var json_obj = JSON.parse(str);
            var that = $(this);
            var minbn = null;
            that.addClass("active").siblings(".upgrade-btn").removeClass("active");
            copy_goods.updateActive(str);
        });
    }
    this.updateActive = function(str) {
        var json_obj = JSON.parse(str);
        var config = json_obj[$('#copy-upgrade .max-upgrade-btn .active').attr("data-sx")].advanced[$('#copy-upgrade .min-upgrade-btn .active').attr('data-month')];
        $("#copy-upgrade #ud-url").attr("href", config.url);
        $("#copy-upgrade .yj-price").text(config.o_price);
        $("#copy-upgrade .cx-price").text(config.price);
    }

    // init
    this.init = function() {
        that.copyshop_list = {};
        that.ajax_copyshop_list_tmp = {};
        that.copyInfoInit();
        that.initFilterMsg()
        setTimeout(that.onsaleTime, 1500)
        setTimeout(that.setDetail, 1500)

        // that.getCommon();
        that.select_area('address1');
        that.setCopyContent('one');

        init_interval = setInterval(that.initUpdateConfig, 50);
        showname_interval = setInterval(that.showName, 50);

        that.change_log_ids = new Array;
        that.change_record_ids = new Array;
        that.change_created_ats = new Array;
        that.again_list = {};

        // menu switch
        $(".JS_menu li").on('click', function() {
            if ($(this).find('a').html() == '复制记录') {
                //初始化条件
                $('.JS_title').val('');
                $('.JS_status').val('');
                $('.JS_status').closest('a').find('span').html('全部状态');
                $('#JS_form_status').removeClass('checked');
                $('.JS_pagesize').val('20');
                $('.JS_pagesize').closest('a').find('span').html('每页20条');
                that.loadCopyList(1, true);
            }
            if ($(this).find('a').html() == '授权复制') {
                that.loadAuthList(1);
            }
            if ($(this).find('a').text() == '复制店铺') {
                // that.getTaobaoCategory('','','two');
                that.setCopyContent('two');
                showshopmsg_interval = setInterval(that.showShopMsg, 50);
            }
            if ($(this).find('a').text() == '复制淘宝/天猫/阿里巴巴/京东' ||
                $(this).find('a').text() == '复制天猫') {
                // that.getTaobaoCategory('','','one');
                that.setCopyContent('one');
            }
            if ($(this).find('a').text() == '复制淘宝精品') {
                // that.getTaobaoCategory('','','one');
                that.setCopyContent('three');
            }

        });

        // status switch
        $('#JS_form_status').on('change', function() {
            if (!$(this).hasClass('checked')) {
                $(".JS_status_options li a[value='2']").trigger('click');
                $('.JS_all_copy_to_other').removeClass('hide');
            } else {
                $(".JS_status_options li a[value='']").trigger('click');
                $('.JS_all_copy_to_other').addClass('hide');
            }
        });

        // copy all fail to other
        $('.JS_all_copy_to_other').click(function() {
            $(".JS_copy_list tr[data-status='2'] .JS_again_copy").each(function() {
                $(this).trigger('click');
            });
        });

        // search
        $(".JS_status, .JS_title, .JS_pagesize").on('change', function() {
            if ($(this).val() == '2') $('#JS_form_status').addClass('checked');
            else $('#JS_form_status').removeClass('checked');

            that.loadCopyList(1, true);
        });
        $(".JS_search_btn").on('click', function() {
            that.loadCopyList(1, true);
        });

        // change page
        $('.JS_page').delegate('li', 'click', function() {
            var page = $(this).find('a').html();
            if (page == '«上一页') page = Number($(this).parent().find('.active a').html()) - 1;
            else if (page == '下一页»') page = Number($(this).parent().find('.active a').html()) + 1;
            if (!$(this).hasClass('disabled') && !$(this).hasClass('active')) that.loadCopyList(page, true);
        });
        $('.JS_quicknav').delegate('a', 'click', function() {
            if ($(this).find('i').hasClass('icon-angle-left')) page = Number($('.JS_page').find('.active a').html()) - 1;
            if ($(this).find('i').hasClass('icon-angle-right')) page = Number($('.JS_page').find('.active a').html()) + 1;
            if (!$(this).hasClass('none-active')) that.loadCopyList(page, true);
        });

        $('.auth_page').delegate('li', 'click', function() {
            var page = $(this).find('a').html();
            if (page == '«上一页') page = Number($(this).parent().find('.active a').html()) - 1;
            else if (page == '下一页»') page = Number($(this).parent().find('.active a').html()) + 1;
            if (!$(this).hasClass('disabled') && !$(this).hasClass('active')) that.loadAuthList(page, true);
        });
        $('.auth_quicknav').delegate('a', 'click', function() {
            if ($(this).find('i').hasClass('icon-angle-left')) page = Number($('.auth_page').find('.active a').html()) - 1;
            if ($(this).find('i').hasClass('icon-angle-right')) page = Number($('.auth_page').find('.active a').html()) + 1;
            if (!$(this).hasClass('none-active')) that.loadAuthList(page, true);
        });

        // price_float change
        $(".JS_price_float, .JS_search_low_price, .JS_search_high_price").on('change keyup click', function() {
            if (this.value != this.value.replace(/[^\d\.]/g, ''))
                this.value = this.value.replace(/[^\d\.]/g, '');

            new_value = this.value.replace(/([0-9]+\.[0-9]{2})[0-9]*/, "$1");
            if (this.value.length != new_value.length)
                this.value = new_value;
        });
        $(".JS_price_float").on('blur', function() {
            new_value = Number(this.value);
            if (this.value.length != new_value.length)
                this.value = new_value;
        });

        // submit save
        $('.JS_submit_save').click(function() {
            that.submitCopyForm();
        });
        $('.JS_urls').on('focus', function() {
            $(this).parent().removeClass('textarea-error');
        });

        // again copy
        $('.JS_copy_list').on('click', '.JS_again_copy', function() {
            that.againCopy($(this).parents('tr').attr('data-log_id'), $(this).parents('tr').attr('data-record_id'), $(this).parents('tr').attr('data-created_at'), $(this).attr('data-is_copy_to_other'), 0);
        });

        // delete copy
        $('.JS_copy_list').on('click', '.JS_delete_copy', function() {
            that.deleteCopy($(this).parents('tr').attr('data-log_id'), $(this).parents('tr').attr('data-record_id'), $(this).parents('tr').attr('data-created_at'));
        });

        $('.JS_copy_list').on('click', '.JS_update_desc', function() {
            that.updateCopy($(this).parents('tr').attr('data-record_id'), $(this).parents('tr').attr('data-created_at'));
        })

        //重新复制本页出错宝贝  有重试按钮的
        $('body').on('click', '.copy_again_btn', function() {
            //修改属性
            var change_list = $('#tab-three .change_copy[data-is_copy_to_other="0"]');
            //错误更改
            var error_list = $('#tab-three .JS_change_error');
            //重试
            var again_list = $('#tab-three .JS_again_copy[data-is_copy_to_other="0"]');

            that.emptyChangeParams();
            that.again_list = {};
            if (!change_list.length && !error_list.length && !again_list.length) {
                showErrorNotice('没有可重试的宝贝！');
            } else {
                var props = new Array;
                var tr, html;
                if (change_list.length > 0) {
                    var change_props;
                    change_list.each(function() {
                        tr = $(this).closest('tr');
                        change_props = tr.find('.change_props').val();
                        change_props = change_props.split("、");
                        props = $.merge(props, change_props);

                        that.change_log_ids.push(tr.data('log_id'));
                        that.change_record_ids.push(tr.data('record_id'));
                        that.change_created_ats.push(tr.data('created_at'));
                    })
                }
                if (error_list.length > 0) {
                    var err_props, correct_error;
                    error_list.each(function() {
                        tr = $(this).closest('tr');
                        correct_error = tr.find('.correct_error');
                        err_props = correct_error.data('props');
                        err_props = err_props.split("、");
                        props = $.merge(props, err_props);

                        that.change_log_ids.push(tr.data('log_id'));
                        that.change_record_ids.push(tr.data('record_id'));
                        that.change_created_ats.push(tr.data('created_at'));
                    })
                }

                $('#changing .list-attr').remove();

                if (props.length > 0) {
                    if (again_list.length > 0) {
                        that.again_list = again_list;
                    }
                    html = that.showChangeProps(props);
                    $('#changing .sui-form').append(html);
                    $('#changing').modal('show');
                } else {
                    if (again_list.length > 0) {
                        again_list.each(function() {
                            that.againCopy($(this).parents('tr').attr('data-log_id'), $(this).parents('tr').attr('data-record_id'), $(this).parents('tr').attr('data-created_at'), $(this).attr('data-is_copy_to_other'), 1);
                        });
                    }
                }
            }
        })

        //删除本页失败记录
        $('body').on('click', '.delete_log_btn', function() {
            var fail_list = $('tr[data-status="2"]');
            if (fail_list.length <= 0) {
                showErrorNotice('没有出错的宝贝！');
            } else {
                fail_list.each(function() {
                    $(this).find('.JS_delete_copy').trigger('click');
                });
            }
        })

        //停止任务
        $('body').on('click', '.stop_btn', function() {
            ajax("/copy_goods/ajaxStopTask", '', function(data) {
                if (data.status == 'OK') {
                    window.copy_goods.dialog('confirm', '确定要停止所有正在复制中的任务？',
                        function() { //确定
                            bigLoading();
                            ajax("/copy_goods/ajaxStopTask", {
                                stop: true
                            }, function(data) {
                                closeBigLoading();
                                if (data.status == 'OK') {
                                    if (data.stop_num) {
                                        alertMsg('共停止' + data.stop_num + '个任务');
                                    } else if (data.stop_shop) {
                                        alertMsg('已停止复制店铺任务');
                                    }
                                } else {
                                    showErrorNotice(data.msg);
                                }
                            })
                        },
                        function() { //取消
                        }, '确定', '取消');
                } else {
                    showErrorNotice(data.msg);
                }
            })
        })

        //清理已删除
        $('body').on('click', '.clear_btn', function() {
            var clear_list = $('tr[data-approve_status=""]');
            if (clear_list.length <= 0) {
                showErrorNotice('没有已删除的宝贝！');
            } else {
                clear_list.each(function() {
                    if ($(this).attr('data-status') != '2') {
                        $(this).find('.JS_delete_copy').trigger('click');
                    }
                });
            }
        })

        //升级弹窗
        $('.more_traffic').on('click', function() {
            $('#copy-upgrade .upgradeModal-text').html("您本月复制流量即将用完，如需复制更多，请升级");
            $('#copy-upgrade').modal('show');
        })

        //标题 删除关键词
        $('body').on('click', '.title_keys', function() {
            $('#titleKeys').modal('show');
        })

        $('body').on('click', '.save_title_keys', function() {
            var keys = $('#title_keys_content').val();
            ajax("/copy_goods/ajax_update_title_keys", {
                keys: keys,
                type: 1
            }, function(data) {
                if (data.status == 'OK') {
                    alertMsg('保存成功');
                } else {
                    showErrorNotice(data.msg);
                }
            })
        })

        //标题 排除关键词
        $('body').on('click', '.exclude_key', function() {
            $('#excludeTitleKeys').modal('show');
        })

        $('body').on('click', '.save_exclude_title_keys', function() {
            var keys = $('#exclude_title_keys_content').val();
            ajax("/copy_goods/ajax_update_title_keys", {
                keys: keys,
                type: 2
            }, function(data) {
                if (data.status == 'OK') {
                    alertMsg('保存成功');
                } else {
                    showErrorNotice(data.msg);
                }
            })
        })

        //标题 替换关键词
        $('body').on('click', '.title_replace', function() {
            $('#replaceTitleKeys').modal('show');
        })

        $('body').on('click', '.save_replace_title_keys', function() {
            var source = new Array;
            var change = new Array;
            $('#replaceTitleKeys [name="source[]"]').each(function() {
                source.push($(this).val());
            })
            $('#replaceTitleKeys [name="change[]"]').each(function() {
                change.push($(this).val());
            })

            var success = true;
            $.each(source, function(k, v) {
                if (($.trim(v) && $.trim(change[k]) == '') ||
                    ($.trim(v) == '' && $.trim(change[k]))
                ) {
                    showErrorNotice('查找关键词 与 替换关键词 必须同时填写或同时留空');
                    success = false;
                    return false;
                }
            })

            if (success) {
                ajax("/copy_goods/ajax_update_title_keys", {
                    source: source,
                    change: change,
                    type: 3
                }, function(data) {
                    if (data.status == 'OK') {
                        alertMsg('保存成功');
                    } else {
                        showErrorNotice(data.msg);
                    }
                })
            } else {
                $('#replaceTitleKeys').modal('show');
            }
        })

        //过滤指定店铺宝贝
        $('body').on('click', '.js_filter_shop', function() {
            $('#shopNames').modal('show');
        })

        $('body').on('click', '.save_shop_names', function() {
            var content = $('#shop_names_content').val();
            ajax("/copy_goods/ajax_update_filter", {
                content: content,
                type: 'shop'
            }, function(data) {
                if (data.status == 'OK') {
                    alertMsg('保存成功');
                } else {
                    showErrorNotice(data.msg);
                }
            })
        })

        //过滤指定品牌宝贝
        $('body').on('click', '.js_filter_brand', function() {
            $('#brands').modal('show');
        })

        $('body').on('click', '.save_brands', function() {
            var content = $('#brands_content').val();
            ajax("/copy_goods/ajax_update_filter", {
                content: content,
                type: 'brand'
            }, function(data) {
                if (data.status == 'OK') {
                    alertMsg('保存成功');
                } else {
                    showErrorNotice(data.msg);
                }
            })
        })

        //去掉详情URL中的图片
        $('body').on('click', '.js_remove_url', function() {
            $('#urls').modal('show');
        })

        $('body').on('click', '.save_urls', function() {
            var content = $('#urls_content').val();
            ajax("/copy_goods/ajax_update_filter", {
                content: content,
                type: 'picurl'
            }, function(data) {
                if (data.status == 'OK') {
                    alertMsg('保存成功');
                } else {
                    showErrorNotice(data.msg);
                }
            })
        })


        // search shop goods
        $('#tab-two .JS_search').click(function() {
            that.copyshop_list = {};
            if ($('.JS_search_nick').val() == '') {
                var warning;
                if (global_data.user.type == 'B')
                    warning = '请填写旺旺';
                else
                    warning = '请填写旺旺或阿里巴巴店铺网址';
                $('.JS_search_nick_error').removeClass('hide').find('div').html(warning);
                return;
            }
            that.updateShopGoodsCheckAllNums();
            //清掉子条件
            if (that.is_js_search_click == undefined || that.is_js_search_click == '1') {
                $('.JS_search_keyword').val('');
                $('.JS_search_low_price').val('');
                $('.JS_search_high_price').val('');
                $('.JS_low_store').val('');
                $('.JS_high_store').val('');
                $('.JS_onsale_type').val(1);
                //初始化店铺分类
                $('.JS_category').val('');
                $('#tab-two .JS_category').closest('a').find('span').text('按类目查询');
            }
            that.is_js_search_click = '1';

            that.searchShopGoods(1);
        });


        $('#tab-two .JS_search_keyword_click').click(function() {
            $("#tab-two .JS_search_low_price, #tab-two .JS_search_high_price, #tab-two .JS_low_store, #tab-two .JS_high_store").val('');
            that.is_js_search_click = '0';
            if ($('#tab-two .JS_shop_type').val() == '2') {
                //初始化店铺分类
                $('.JS_category').val('');
                $('#tab-two .JS_category').closest('a').find('span').text('按类目查询');
            }
            $("#tab-two .JS_search").trigger('click');
        });
        $('#tab-two .JS_search_category_click').click(function() {
            $("#tab-two .JS_search_low_price, #tab-two .JS_search_high_price, #tab-two .JS_low_store, #tab-two .JS_high_store").val('');
            that.is_js_search_click = '0';
            if ($('#tab-two .JS_shop_type').val() == '2') {
                $('#tab-two .JS_search_keyword').val('');
            }
            $("#tab-two .JS_search").trigger('click');
        });


        $('#tab-two .JS_search_price_click, #tab-two .JS_search_sale_click').click(function() {
            that.is_js_search_click = '0';
            $("#tab-two .JS_search").trigger('click');
        });
        $('.JS_development_version label em').click(function() {
            setTimeout(function() {
                $("#tab-two .JS_search").trigger('click');
            }, 10)
        });

        // search shop goods ordertype switch
        $('#tab-two .JS_search_order_type').on('click change', function() {
            that.searchShopGoods(1);
        });

        // 修改排序触发搜索
        $('#tab-two #orderby_for_taobao_tmall, #tab-two #orderby_for_1688').on('change', function() {
            that.searchShopGoods(1);
        });

        $('body').on('change', '#tab-two .JS_category', function() {
            var category = $('#tab-two .JS_category').val();
            if (category) {
                $('#category_options li a').each(function(k, v) {
                    if ($(this).attr('value') == category) {
                        $('#tab-two .JS_category').closest('a').find('span').text($(this).text());
                        return false;
                    }
                })
            }
            if ($('#tab-two .JS_shop_type').val() != '2')
                that.searchShopGoods(1);
        })

        //搜索店铺 选择类目
        $('#tab-two .JS_formlist-top').on('click', function() {
            if ($('#category_options li').length <= 0) { //类目未加载 ajax获取
                var shop_id = $('[name="shop_id"]').val();
                var shop_type = $('.JS_shop_type').val();
                var nick = $('.JS_search_nick').val();

                if (shop_id && shop_type && nick != '') {
                    ajax('/copy_goods/ajaxGetShopCategory', {
                        shop_id: shop_id,
                        shop_type: shop_type,
                        nick: nick
                    }, function(data) {
                        if (data.status == 'OK') {
                            $(".js_category").html(data.list_content);
                            $("#category_options").html(data.list_html);
                            $(".js_category_options").html(data.list_html);
                        }
                    })
                }
            }
        })

        // search xinpin item
        $('.JS_is_xinpin').on('change', function() {
            that.searchShopGoods(1);
        });

        // change page
        $('.JS_page_copy_shop').delegate('li', 'click', function() {
            var page = $(this).find('a').html();
            if (page == '«上一页') page = Number($(this).parent().find('.active a').html()) - 1;
            else if (page == '下一页»') page = Number($(this).parent().find('.active a').html()) + 1;
            if (!$(this).hasClass('disabled') && !$(this).hasClass('active')) that.searchShopGoods(page);
        });
        $('.JS_quicknav_copy_shop').delegate('a', 'click', function() {
            if ($(this).find('i').hasClass('icon-angle-left')) page = Number($('.JS_page_copy_shop').find('.active a').html()) - 1;
            if ($(this).find('i').hasClass('icon-angle-right')) page = Number($('.JS_page_copy_shop').find('.active a').html()) + 1;
            if (!$(this).hasClass('none-active')) that.searchShopGoods(page);
        });
        $('.JS_page_copy_shop').delegate('.page-confirm', 'click', function() {
            var page = $(this).siblings('.page-num').val();
            var pages = Number($(this).siblings('.page-end').val());

            if (page == '' || page == 0) page = 1;
            if (page > pages) page = pages;
            $(this).siblings('.page-num').val(page);
            that.searchShopGoods(page);
        });

        // search shop goods onecopy
        $('#tab-two').on('click', '.JS_copy', function(event, num_iid, url) {
            var thisobj = $(this);
            var urls = url == undefined ? $(this).parents('tr').attr('data-url') : url;
            var num_iid = num_iid == undefined ? $(this).parents('tr').attr('data-num_iid') : num_iid;

            //批量提交
            if (window.copy_goods.copy_shop_many_num_iid != undefined) {
                var copy_shop_many_num_iid = window.copy_goods.copy_shop_many_num_iid;
                window.copy_goods.copy_shop_many_num_iid = undefined;
                var urls = url = '';
                var shop_type = $('#tab-two .JS_shop_type').val();
                $.each(copy_shop_many_num_iid, function(i, n) {
                    if (shop_type == '1')
                        url = 'https://item.taobao.com/item.htm?id=' + n;
                    else if (shop_type == '2')
                        url = 'https://detail.1688.com/offer/' + n + '.html';
                    that.updateShopGoodsCheckAllNums(n, url, 'pop');
                    urls = urls + url + "\n";
                });
            } else {
                that.updateShopGoodsCheckAllNums(num_iid, urls, 'pop');
            }

            //过滤店铺
            var filter = that.filterShop();
            if (filter.status == 'OK') {
                that.dialog('fail', '您设置了过滤该店铺的宝贝不复制', '', '', '知道了', '', '复制失败');
                return false;
            }

            var params = that.getShopGoodsParams(urls);
            if (!params) return false;
            ajax('/copy_goods/ajaxSaveCopy', params, function(data) {
                if (data.status == 'OK') {
                    if (url == undefined) {
                        var checkbox = thisobj.parents('tr').find('label').checkbox();
                        checkbox.checkbox('uncheck');
                        checkbox.checkbox('disable');
                        thisobj.addClass('hide');
                        thisobj.next().removeClass('hide');
                    } else {
                        //批量状态
                        if (copy_shop_many_num_iid != undefined) {
                            $.each(copy_shop_many_num_iid, function(i, n) {
                                var checkbox = $("#JS_shop_goods_list tr[data-num_iid='" + n + "']").find('label').checkbox();
                                var thisobj = $("#JS_shop_goods_list tr[data-num_iid='" + n + "']").find('.JS_copy');
                                checkbox.checkbox('uncheck');
                                checkbox.checkbox('disable');
                                thisobj.addClass('hide');
                                thisobj.next().removeClass('hide');
                            });
                        }
                    }
                } else if (data.status == 'FAIL') {
                    that.dialog('fail', data.msg, '', '', '知道了', '', '复制失败');
                } else if (data.status == 'COPY_UPGRADE') {
                    $('#copy-upgrade .upgradeModal-text').html(data.msg);
                    $('#copy-upgrade').modal('show');
                }
            });
        });

        // search shop checkall goods
        $('#tab-two').on('click', '.JS_check_all', function() {
            if ($(this).prop('checked') == true)
                var notcheckbox = $('#tab-two #JS_shop_goods_list .JS_copy_checkbox').not(':checked').not(':disabled');
            else var notcheckbox = $('#tab-two #JS_shop_goods_list .JS_copy_checkbox:checked').not(':disabled');
            if (notcheckbox.length > 0) {
                notcheckbox.each(function(i) {
                    $(this).trigger('click');
                });
            }
        });
        $('#tab-two').on('change', '.JS_copy_checkbox', function(event, num_iid) {
            if ($("#JS_shop_goods_list .JS_copy_checkbox").not(':checked').not(':disabled').length > 0 || $("#JS_shop_goods_list .JS_copy_checkbox:checked").length <= 0)
                $('#tab-two .JS_check_all').parent().checkbox().checkbox('uncheck');
            else $('#tab-two .JS_check_all').parent().checkbox().checkbox('check');

            //提示选中数
            if ($(this).prop('checked') == true) {
                var this_num_iid = $(this).parents('tr').attr('data-num_iid');
                copyshop_list_length = 0;
                for (var item in that.copyshop_list) copyshop_list_length++;
                if (copyshop_list_length >= 200 && that.ajax_copyshop_list_tmp[this_num_iid] == undefined) {
                    $(this).prop("checked", false);
                    return $('#tab-two .JS_checkbox_error').css('display', 'block');
                }
            }

            //更新已选中
            var num_iid = $(this).parents('tr').attr('data-num_iid');
            var url = $(this).parents('tr').attr('data-url');
            if ($(this).prop('checked') == true)
                that.updateShopGoodsCheckAllNums(num_iid, url, 'push');
            else
                that.updateShopGoodsCheckAllNums(num_iid, url, 'pop');
        });

        // body click
        $(document).click(function(e) {
            var $target = $(e.target);
            if (!(!$target.hasClass("checkbox-pretty") && !$target.closest(".checkbox-pretty").length)) {
                return;
            }
            if (!(!$target.hasClass("JS_checkbox_error") && !$target.closest(".JS_checkbox_error").length)) {
                return;
            }
            $('#tab-two .JS_checkbox_error').css('display', 'none');
            $('#modal-state2').modal('hide');
            $('#modal-error2').modal('hide');
        });

        // search shop goods copy page
        $('#tab-two').on('click', '.JS_copy_page', function() {
            //过滤店铺
            var filter = that.filterShop();
            if (filter.status == 'OK') {
                that.dialog('fail', '您设置了过滤该店铺的宝贝不复制', '', '', '知道了', '', '复制失败');
                return false;
            }

            var num_iids = [];
            var urls = [];
            var count = 0;
            var copy_list = $("#tab-two #JS_shop_goods_list .JS_copy_checkbox").not(':disabled');
            copy_list.each(function(i) {
                if (!$(this).parents('tr').data('repeat')) {
                    num_iids.push($(this).parents('tr').attr('data-num_iid'));
                    urls.push($(this).parents('tr').attr('data-url'));
                    count++;
                }
            });
            if (count == 0) {
                that.dialog('fail', '复制的宝贝已存在复制记录中', '', '', '知道了', '', '复制失败');
            } else {
                var shop_type = $('#tab-two .JS_shop_type').val();
                var cid = $("#tab-two .JS_cid:last").prop('cid');
                if (!cid && $("#tab-two .JS_cid").length > 1) {
                    showErrorNotice('请选择完整类目', true);
                    return false;
                }
                if (!cid && shop_type == '2') {
                    showErrorNotice('请选择淘宝类目', true);
                    return false;
                }

                that.checkUrl('https://item.taobao.com/item.htm?id=42319779792', function() {
                    if ($(this).html() == '正在复制本页...') return;
                    $(this).html('正在复制本页...');
                    window.copy_goods.copy_shop_many_num_iid = num_iids;
                    $('#JS_shop_goods_list tr').eq(0).find('.JS_copy').trigger('click');
                    $(this).html('本页全部复制');

                    that.dialog('nobtn', "宝贝已经转入后台复制中，预计需要一段时间，请稍候在“复制记录”中查看！");
                });
            }
        });

        // search shop goods copy checkboxs
        $('#tab-two').on('click', '.JS_copy_checked', function() {
            var urls = [];
            var count = 0;
            $.each(that.copyshop_list, function(i, n) {
                urls.push(n);
                count++;
            });
            if (count == 0) {
                that.dialog('fail', '您还没有选择宝贝，请先选取！', '', '', '知道了', '', '请先选择宝贝！');
            } else {
                //过滤店铺
                var filter = that.filterShop();
                if (filter.status == 'OK') {
                    that.dialog('fail', '您设置了过滤该店铺的宝贝不复制', '', '', '知道了', '', '复制失败');
                    return false;
                }

                urls = urls.join("\r");
                $('#tab-two .del_repeat').removeClass('checked');
                if ($('#tab-two .JS_shop_type').val() == '1') {
                    that.checkUrl(urls, function() {
                        if ($(this).html() == '正在复制选中...') return;

                        $(this).html('正在复制选中...');
                        var num_iids = [];
                        $.each(that.copyshop_list, function(i, n) {
                            num_iids.push(i);
                        });
                        $(this).html('复制选中宝贝');

                        window.copy_goods.copy_shop_many_num_iid = num_iids;
                        $('#JS_shop_goods_list tr').eq(0).find('.JS_copy').trigger('click');

                        that.dialog('nobtn', "宝贝已经转入后台复制中，预计需要一段时间，请稍候在“复制记录”中查看！");
                    }, 1);
                } else if ($('#tab-two .JS_shop_type').val() == '2') {
                    var cid = $("#tab-two .JS_cid:last").prop('cid');
                    if (!cid && $("#tab-two .JS_cid").length > 1) {
                        showErrorNotice('请选择完整类目', true);
                        return false;
                    }
                    if (!cid) {
                        showErrorNotice('请选择淘宝类目', true);
                        return false;
                    }

                    that.check1688Url(urls, function() {
                        if ($(this).html() == '正在复制选中...') return;

                        $(this).html('正在复制选中...');
                        var num_iids = [];
                        $.each(that.copyshop_list, function(i, n) {
                            num_iids.push(i);
                        });
                        $(this).html('复制选中宝贝');

                        window.copy_goods.copy_shop_many_num_iid = num_iids;
                        $('#JS_shop_goods_list tr').eq(0).find('.JS_copy').trigger('click');

                        that.dialog('nobtn', "宝贝已经转入后台复制中，预计需要一段时间，请稍候在“复制记录”中查看！");
                    });
                }
            }
        });

        // copy all goods
        $('#tab-two').on('click', '.JS_copy_all', function() {
            var free_warning_msg = '免费版不支持复制全店，请升级';
            var keyword = $('#tab-two .JS_search_keyword').val();
            var category = $('#tab-two .JS_category').val();
            var category_name = '';
            var task_num = '';
            if (category) category_name = $('#tab-two .JS_category').closest('a').find('span').text();

            if ($(this).attr('copy_search') == '1') {
                free_warning_msg = '免费版不支持复制搜索结果，请升级';

                //搜索 关键词 或 类目 才可使用
                if (keyword == '' && category == '') {
                    that.dialog('fail', '请搜索关键词或类目', '', '', '知道了', '', '错误提示');
                    return false;
                }
                var search_param = {
                    keyword: keyword,
                    category: category,
                    category_name: category_name,
                }
            } else if ($(this).attr('copy_nums') == '1') {
                free_warning_msg = '免费版不支持复制结果，请升级';
                var task_num = parseInt($('#tab-two .copy_count_num').text());
                var search_param = {
                    keyword: keyword,
                    category: category,
                    category_name: category_name,
                }
            }

            if (global_data.version_no <= 1) { //免费版 不支持复制全店
                that.dialog('fail', free_warning_msg, function() {
                    $('#copy-upgrade .upgradeModal-text').html(free_warning_msg);
                    $('#copy-upgrade').modal('show');
                }, '', '立即升级', '', '请升级');
                return false;
            }

            //过滤店铺
            var filter = that.filterShop();
            if (filter.status == 'OK') {
                that.dialog('fail', '您设置了过滤该店铺的宝贝不复制', '', '', '知道了', '', '复制失败');
                return false;
            }

            //复制参数
            var params = that.getShopGoodsParams('');
            if (!params) return false;
            //var month_cancopy_count = (Number($('.JS_month_cancopy_count').text()) - Number($('.JS_month_copyed_count').text()));
            var month_rest = Number($('.month_rest').text());
            if (month_rest <= 0) {
                msg = "<br />您本月复制宝贝数量已用完，如果还需要复制更多请升级。";
            } else {
                var store_type = ($('.JS_onsale_type').val() == '2') ? '仓库中' : '出售中';
                var msg_find = "确认全部复制？";
                var total = $(".JS_copy_all").attr('data-total');
                if (!search_param) {
                    total = $("[name='shopall_nums']").val();
                }

                if ($('.JS_shop_type').val() != 2)
                    msg_find = "共找到" + store_type + "<span style='color:red'>" + total + "</span>个宝贝，" + msg_find;
                msg = msg_find;

                if (task_num) {
                    var msg_num = '';
                    if ($('.JS_shop_type').val() != 2) {
                        msg_num = "共找到" + store_type + "<span style='color:red'>" + total + "</span>个宝贝，";
                    }
                    msg_num += "确定复制前" + task_num + "个宝贝？";
                    msg = msg_num;
                    params.task_num = task_num;
                } else if (params.cid) {
                    if ($('.JS_shop_type').val() == '2') {
                        msg = "<span style='color:red'>确定将该店铺宝贝复制到指定类目？</span><br>";
                    } else {
                        msg = "<span style='color:red'>确定将" + total + "个宝贝复制到指定类目？</span><br>";
                    }
                    msg += '类目：';
                    var cid_group = new Array;
                    $('.JS_cid').each(function() {
                        cid_group.push($(this).val());
                    })
                    msg += cid_group.join('>>');
                }
            }
            msg = msg + "<br /><br /><span style='color:#999;'>本月复制数量用完后，超出部分将不会被复制。</span>";

            window.copy_goods.dialog('confirm', msg,
                function() { //确定
                    bigLoading();

                    if (!params) {
                        closeBigLoading();
                        return false;
                    }
                    params.nick = $('#tab-two .JS_search_nick').val();
                    params.development_version = $("[name=development_version]").val();
                    params.shop_count = $(".JS_copy_all").attr('data-total');
                    params.is_onsale = $('.JS_onsale_type').val();
                    if (search_param) params.search_param = search_param;

                    ajax('/copy_goods/ajaxCopyShopAll', params, function(data) {
                        closeBigLoading();
                        if (data.status == 'OK') {
                            that.dialog('nobtn', "宝贝已经转入后台复制中，预计需要一段时间，请稍候在“复制记录”中查看！");
                        } else {
                            if (data.status == 'COPY_UPGRADE') {
                                $('#copy-upgrade .upgradeModal-text').html(data.msg);
                                $('#copy-upgrade').modal('show');
                            } else that.dialog('fail', data.msg, '', '', '知道了', '', '错误提示');
                        }
                    });
                },
                function() { //取消
                }, '确定', '取消');
        });

        $('#tab-four').on('click', '.add_auth', function() {
            var nick = $.trim($('[name="nickname"]').val());
            if (nick != '') {
                if (global_data.user.type == 'C') { //淘宝店铺无法授权给天猫店铺
                    if (nick.indexOf('官方旗舰') >= 0 ||
                        nick.indexOf('专营') >= 0 ||
                        nick.indexOf('旗舰店') >= 0 ||
                        nick.indexOf('专营店') >= 0 ||
                        nick.indexOf('专卖店') >= 0 ||
                        nick.indexOf('旗舰') >= 0) {
                        showErrorNotice('因数据结构不同，天猫不能复制淘宝宝贝，您无法授权给天猫店铺', true);
                        return false;
                    }
                }

                ajax('/copy_goods/addAuth', {
                    nick: nick
                }, function(data) {
                    if (data.status == 'OK') {
                        var html = '<tr data-nick="' + data.receiver + '">';
                        html += '<td>' + data.receiver + '</td>';
                        html += '<td>有效</td>';
                        html += '<td><a class="new-btn del_auth" href="javascript:;">删除授权</a></td></tr>';
                        $('.auth_list').show();
                        $('.auth_list_error').hide();
                        $('.auth_list').prepend(html);
                        showSuccessNotice(data.receiver + '现在能够通过授权复制您店铺宝贝', '', '', '授权成功');
                        $('[name="nickname"]').val('');
                    } else if (data.status == 'Repeat') {
                        that.dialog('fail', data.msg, '', '', '知道了', '', '错误提示');
                        $('[name="nickname"]').val('');
                    } else if (data.status == 'NoAuth') {
                        $('#modal-error2').modal('show');
                    }
                }, 'POST')
            }
        })

        $('#tab-four').on('click', '.del_auth', function() {
            var tr = $(this).closest('tr');
            var nick = tr.data('nick');
            ajax('/copy_goods/delAuth', {
                nick: nick
            }, function(data) {
                if (data.status == 'OK') {
                    tr.remove();
                }
            }, 'POST')
        })

        $('.JS_search_nick').keydown(function(e) {
            if (e.keyCode == 13) {
                $(this).trigger('blur');
                $('#tab-two .JS_search').trigger('click');
            }
        });
        $('.JS_search_nick').blur(function() {
            var val = $(this).val();
            ajax('/copy_goods/authCheck', {
                nick: val
            }, function(data) {
                if (data.status == 'OK') {
                    that.auth_content_init('open');
                } else {
                    that.auth_content_init('close');
                }
            }, 'POST', {
                'show_loading': 1
            })
        });

        //纠错
        $('body').on('click', '.correct_error', function() {
            bigLoading();
            var props = $(this).data('props');
            var cid = $(this).data('cid');
            var pids = $(this).data('pids');
            if (pids) pids = pids.toString();
            var tr = $(this).closest('tr');
            var created_at = tr.data('created_at');
            var record_id = tr.data('record_id');
            var log_id = tr.data('log_id');
            if (!prop_values[cid]) prop_values[cid] = new Object;

            //基本信息
            ajax('/copy_goods/ajaxGetBaseInfo', {
                log_id: log_id,
                created_at: created_at,
                record_id: record_id
            }, function(data) {
                if (data.status == 'OK') {
                    var info = data.info;
                    $('#editing .source_title').html('<a href="' + info.url + '" target="_blank">' + info.source_title + '</a>');
                    $('#editing .error_msg').html(info.error_msg);
                    $('#editing .record_id').val(info.sync_record_id);
                    $('#editing .log_id').val(info.id);
                    $('#editing .created_at').val(info.created_at);
                    $('#editing .category_id').val(info.source_categoryId);
                }
            }, 'POST', {
                show_loading: 1
            }, false);

            //属性
            props = props.split("、");

            if (pids) pids = pids.split(",");
            $('#editing .list-attr').remove();

            var html = '';
            for (num = 0; num < props.length; num++) {
                if (pids) pid = pids[num];
                else if (props[num] == '品牌') pid = '20000'; //品牌pid为20000
                else pid = '';

                if (!prop_values[cid][pid] || !pid) {
                    ajax('/copy_goods/ajaxErrorCorrect', {
                        props: props[num],
                        cid: cid,
                        pids: pid
                    }, function(data) {
                        if (data.status == 'OK') {
                            var content = data.content;
                            var values, data_istype;
                            var ii;
                            for (i in content) {
                                html += assemble_content(content[i], i, cid);
                            }
                        } else {
                            alert('属性获取失败');
                            return false;
                            closeBigLoading();
                        }
                    }, 'POST', {
                        show_loading: 1
                    }, false)
                } else {
                    html += assemble_content(prop_values[cid][pid], prop_name[pid], cid);
                }
            }

            $('#editing .sui-form').append(html);
            closeBigLoading();
            bind_scroll();
            $('#editing').modal('show');
        });

        $('body').on('click', '.correct_error_btn', function() {
            var pid, vid, str, input, name, prop_name;
            var props = [];
            var input_pids = [];
            var log_id = $('#editing .log_id').val();
            var record_id = $('#editing .record_id').val();
            var created_at = $('#editing .created_at').val();
            var pass = true;

            $('#editing .input-text').each(function() {
                pid = $(this).data('pid');
                vid = $(this).data('vid');
                str = $(this).val();
                if (str == '') {
                    alert('请填写属性');
                    pass = false;
                    return false;
                }
                if (vid) {
                    props.push(pid + ':' + vid);
                } else {
                    input_pids.push(pid + ':' + str);
                }
            })

            if (pass) {
                $('#editing .only_input').each(function() {
                    pid = $(this).data('pid');
                    str = $(this).val();
                    if (str) input_pids.push(pid + ':' + str);
                })
                var params = {
                    'props': props,
                    'input_pids': input_pids,
                }
                ajax('/copy_goods/ajaxErrorCorrectCopy', {
                    log_id: log_id,
                    record_id: record_id,
                    created_at: created_at,
                    params: params
                }, function(data) {
                    if (data.status == 'OK') {
                        var item = $(".JS_copy_list tr[data-log_id='" + log_id + "']");
                        if (item.length < 0) return;
                        var tds = item.find('td');
                        tds.eq(1).html("复制中...");
                        tds.eq(2).html("");
                        tds.eq(3).html("");
                        tds.eq(5).html("");
                        item.attr('data-status', '0');
                        $('#editing').modal('hide');
                        $('#editing .list-attr').remove();
                        that.check_copy_list_status();
                    } else alert(data.msg);
                }, 'POST')
            }
        })

        $('body').on('click', '.JS_change_error', function() {
            var btn = $(this).closest('tr').find('.correct_error');
            btn.trigger('click');
        })

        //修改属性
        $('body').on('click', '.change_copy', function() {
            var props = $(this).closest('tr').find('.change_props').val();
            var tr = $(this).closest('tr');
            props = props.split("、");
            that.again_list = {};
            if (props) {
                $('#changing .list-attr').remove();
                that.emptyChangeParams();

                that.change_log_ids.push(tr.data('log_id'));
                that.change_record_ids.push(tr.data('record_id'));
                that.change_created_ats.push(tr.data('created_at'));

                var html = that.showChangeProps(props);

                $('#changing .sui-form').append(html);
                $('#changing').modal('show');
            }
        })

        $('body').on('click', '.change_copy_btn', function() {
            var props = new Array;
            var pass = true;
            $('#changing .input-name').each(function() {
                if ($(this).next('.input-text').val()) {
                    props.push($(this).val() + ':' + $(this).next('.input-text').val());
                } else {
                    alert('请填写属性值');
                    pass = false;
                    return false;
                }
            })

            if (that.change_log_ids.length > 0 && pass && props.length > 0) {
                var params = {
                    log_ids: that.change_log_ids,
                    record_ids: that.change_record_ids,
                    created_ats: that.change_created_ats,
                    props: props
                }
                ajax('/copy_goods/ajaxChangePropsCopy', params, function(data) {
                    if (data.status == 'OK') {
                        var list = data.success_msg;
                        var error = data.error_msg;

                        if (list) {
                            $.each(list, function(i, log_id) {
                                var item = $(".JS_copy_list tr[data-log_id='" + log_id + "']");
                                if (item.length < 0) return;
                                var tds = item.find('td');
                                tds.eq(1).html("复制中...");
                                tds.eq(2).html("");
                                tds.eq(3).html("");
                                tds.eq(5).html("");
                                item.attr('data-status', '0');
                            })
                            that.check_copy_list_status();
                        }
                        if (error) {

                        }
                        $('#changing').modal('hide');
                    } else {
                        var error = data.error_msg;

                    }
                })
            }
            if (that.again_list.length > 0) {
                that.again_list.each(function() {
                    that.againCopy($(this).parents('tr').attr('data-log_id'), $(this).parents('tr').attr('data-record_id'), $(this).parents('tr').attr('data-created_at'), $(this).attr('data-is_copy_to_other'), 1);
                });
                that.again_list = {};
            }
        })


        //上架
        $('body').on('click', '.onsale-item', function() {
            var num_iid = $(this).data('num_iid');
            var num = $(this).data('num');
            var div = $(this).closest('div');
            ajax("/items/up_listing", {
                'num_iid': num_iid,
                'num': num
            }, function(data) {
                if (data.status == 'OK') {
                    that.alertMsg('上架成功');
                    div.remove();
                } else if (data.status == 'FAIL') {
                    that.alertMsg('上架失败:' + data.msg);
                }
            })
        })

        //删除
        $('body').on('click', '.del-item', function() {
            var item = $(this).closest('tr');
            var record_id = item.attr('data-record_id');
            var created_at = item.attr('data-created_at');
            ajax("/copy_goods/ajax_del_item", {
                record_id: record_id,
                created_at: created_at
            }, function(data) {
                if (data.status == 'OK') {
                    item.fadeOut('slow', function() {
                        $(this).remove();
                    });
                } else that.dialog('fail', data.msg, '', '', '知道了', '', '删除失败');
            });
        })

        //跳转复制宝贝记录
        $('body').on('click', '.copy_record', function() {
            $('a[href="#tab-three"]').click();
        })

        $('body').on('change', ".location_type", function() {
            if ($(this).val() == '2') {
                $('#address1_state').closest('span.select').hide();
                $('#address1_city').closest('span.select').hide();
            } else if ($(this).val() == '1') {
                $('#address1_state').closest('.select').show();
                $('#address1_city').closest('.select').show();
            }
        })

        that.setCatsSearch('');

        /*暂用此地 复制淘宝精品  tab-five*/
        var params_copy_taobao_list = {
            keyword: '',
            baoyou: '', //包邮
            filter_tianmao: '', //是否天猫
            auction_tag: [], //如果新品  传1154
            reserve_price_start: '', //价格起点
            reserve_price_end: '', //价格终点
            sort: '', //综合排序
            page: 1,
        }

        //搜索淘宝精品
        $('#tab-five .JS_search').click(function() {
            that.copyshop_list = {};
            if ($('.JS_search_taobao').val() == '') {
                var warning;
                warning = '请填写宝贝关键词';
                $('.js_search_taobao_error').removeClass('hide').find('div').html(warning);
                return;
            }
            that.updateShopGoodsCheckAllNums();
            //清掉子条件
            if (that.is_js_search_click == undefined || that.is_js_search_click == '1') {
                $('.JS_search_keyword').val('');
                $('.JS_search_low_price').val('');
                $('.JS_search_high_price').val('');
                $('.JS_low_store').val('');
                $('.JS_high_store').val('');
                $('.JS_onsale_type').val(1);
                //初始化店铺分类
                $('.JS_category').val('');
                $('#tab-two .JS_category').closest('a').find('span').text('按类目查询');
            }
            that.is_js_search_click = '1';

            searchTaobao(1);
        });

        //监听回车搜索
        $('.JS_search_taobao').keyup(function(event) {
            if (event.keyCode == 13) {
                $('#tab-five .JS_search').trigger("click")
            }
        });

        var searchTaobao = function(type) {
            $("html,body").animate({
                scrollTop: $("#JS_taobao_goods_list").closest('table').offset().top - 70
            }, 100)
            $(".JS_formlist .JS_check_all").parent().checkbox().checkbox('uncheck');
            $('#tab-five .JS_copy_checkbox_num').html(0)
            that.copytaobao_list = []


            //重置分类
            bigLoading();
            $('.js_search_taobao_error').addClass('hide');

            //更换关键词重新搜索  重置参数
            if (type == 1) {
                $('.js_select_free_delivery').checkbox('uncheck')
                $('.js_select_tianmao').checkbox('uncheck')
                $('.js_select_new').checkbox('uncheck')
                params_copy_taobao_list.baoyou = ''
                params_copy_taobao_list.filter_tianmao = ''
                params_copy_taobao_list.auction_tag = []
                params_copy_taobao_list.loc = ''
                params_copy_taobao_list.sort = ''
                params_copy_taobao_list.page = 1
                $('.JS_search_taobao_type').val('')
                $('.js_sort_type li').removeClass('active')
                $('.js_sort_type .js_sort_li').addClass('active')
                $('#js_sort_span').html('综合排序')
                $('#send_span').html('发货地')
                $('.js_select_content label').hide()
            }

            //如果是天猫用户，强制搜索天猫
            if (global_data.user.type != 'C') {
                params_copy_taobao_list.filter_tianmao = 1
                $('.js_select_tianmao').checkbox('check')
                $('.js_select_tianmao').checkbox('disable')
            }

            ajax('/copy_goods/ajax_get_search_taobao_results', params_copy_taobao_list, function(data) {
                if (data.status == 'OK') {
                    var html = template('script-taobao-goods-list', data);
                    $('#JS_taobao_goods_list').html(html);
                    if (!data.data.page.pagenav) {
                        $('.JS_page_copy_taobao').html('')
                    } else {
                        $('.JS_page_copy_taobao').html(data.data.page.pagenav)
                    }
                    $('#tab-five .JS_formlist').removeClass('hide')
                    $('#tab-five .JS_list_error_copy_shop').hide()
                    if (data.data.filter) {
                        $.each(data.data.filter, function(index, i) {
                            if (i.title == '包邮') {
                                $('.js_select_free_delivery').show()
                            }
                            if (i.title == '新品') {
                                $('.js_select_new').show()
                            }
                            if (i.title == '天猫') {
                                $('.js_select_tianmao').show()
                            }
                        })
                    }
                } else {
                    if (data.status == 'FAIL') {
                        if (type == 1) {
                            $('#tab-five .JS_formlist').addClass('hide')
                            $('.js_search_taobao_error').removeClass('hide').find('div').html(data.msg);
                        } else {
                            showErrorNotice(data.msg)
                            $('#JS_taobao_goods_list').html('');
                            $('.JS_page_copy_taobao').html('')
                            $('#tab-five .JS_list_error_copy_shop').show()
                        }

                    }
                }

            })
        }

        //关键词
        $('.JS_search_taobao').change(function() {
            params_copy_taobao_list.keyword = $(this).val()
        })

        //条件筛选
        //包邮
        $('.js_select_free_delivery').on('click', 'input', function() {
                if ($(this).prop('checked') == true) {
                    params_copy_taobao_list.baoyou = 1
                } else {
                    params_copy_taobao_list.baoyou = ''
                }
                params_copy_taobao_list.page = 1
                searchTaobao()
            })
            //天猫
        $('.js_select_tianmao').on('click', 'input', function() {
                if ($(this).prop('checked') == true) {
                    params_copy_taobao_list.filter_tianmao = 1
                } else {
                    params_copy_taobao_list.filter_tianmao = ''
                }
                params_copy_taobao_list.page = 1
                searchTaobao()
            })
            //新品
        $('.js_select_new').on('click', 'input', function() {
                if ($(this).prop('checked') == true) {
                    params_copy_taobao_list.auction_tag.push(1154)
                } else {
                    params_copy_taobao_list.auction_tag = []
                }
                params_copy_taobao_list.page = 1
                searchTaobao()
            })
            //发货地选择
        $('.send_where').hover(function() {
            $('.send_ul').show()
            if (params_copy_taobao_list.loc) {
                $('.cancel_address').show()
            } else {
                $('.cancel_address').hide()
            }
        }, function() {
            $('.send_ul').hide()
        })

        $('.send_where li').click(function() {
            params_copy_taobao_list.loc = $(this).html()
            $('#send_span').html($(this).html())
            searchTaobao()
        })

        $('.js_cancel_address').click(function() {
            params_copy_taobao_list.loc = ''
            $('#send_span').html('发货地')
            searchTaobao()
        })

        $('.js_sure_address').click(function() {
            params_copy_taobao_list.loc = $('.address_input').val()
            $('#send_span').html($('.address_input').val())
            searchTaobao()
        })

        $('.address_input').keyup(function(event) {
            if (event.keyCode == 13) {
                $('#tab-five .js_sure_address').trigger("click")
            }
        })

        //排序
        $('.JS_search_taobao_type').change(function() {
            params_copy_taobao_list.sort = $(this).val()
            params_copy_taobao_list.page = 1
            searchTaobao()
        })


        // 分頁
        $('.JS_page_copy_taobao').delegate('li', 'click', function() {
            var page = $(this).find('a').html();
            if (page == '«上一页') page = Number($(this).parent().find('.active a').html()) - 1;
            else if (page == '下一页»') page = Number($(this).parent().find('.active a').html()) + 1;
            if (!$(this).hasClass('disabled') && !$(this).hasClass('active')) {
                params_copy_taobao_list.page = page
                searchTaobao();
            }
        });
        $('.JS_quicknav_copy_taobao').delegate('a', 'click', function() {
            if ($(this).find('i').hasClass('icon-angle-left')) page = Number($('.JS_page_copy_shop').find('.active a').html()) - 1;
            if ($(this).find('i').hasClass('icon-angle-right')) page = Number($('.JS_page_copy_shop').find('.active a').html()) + 1;
            if (!$(this).hasClass('none-active')) {
                params_copy_taobao_list.page = page
                searchTaobao();
            }
        });
        $('.JS_page_copy_taobao').delegate('.page-confirm', 'click', function() {
            var page = $(this).siblings('.page-num').val();
            var pages = Number($(this).siblings('.page-end').val());

            if (page == '' || page == 0) page = 1;
            if (page > pages) page = pages;
            $(this).siblings('.page-num').val(page);
            params_copy_taobao_list.page = page
            searchTaobao();
        });

        // 全选
        $('#tab-five').on('click', '.JS_check_all', function() {
            if ($(this).prop('checked') == true) {
                var notcheckbox = $('#tab-five #JS_taobao_goods_list .JS_copy_checkbox').not(':checked').not(':disabled');
            } else {
                var notcheckbox = $('#tab-five #JS_taobao_goods_list .JS_copy_checkbox:checked').not(':disabled');
            }
            if (notcheckbox.length > 0) {
                notcheckbox.each(function(i) {
                    $(this).trigger('click');
                });
            }
        });

        //选中或取消
        $('#tab-five').on('change', '.JS_copy_checkbox', function(event, num_iid) {
            if ($("#JS_taobao_goods_list .JS_copy_checkbox").not(':checked').not(':disabled').length > 0 || $("#JS_taobao_goods_list .JS_copy_checkbox:checked").length <= 0) {
                $('#tab-five .JS_check_all').parent().checkbox().checkbox('uncheck');
            } else {
                $('#tab-five .JS_check_all').parent().checkbox().checkbox('check');
            }

            //提示选中数
            if ($(this).prop('checked') == true) {
                var this_num_iid = $(this).parents('tr').attr('data-num_iid');
                if (that.copytaobao_list.length >= 200 && that.ajax_copyshop_list_tmp[this_num_iid] == undefined) {
                    $(this).prop("checked", false);
                    return $('#tab-five .JS_checkbox_error').css('display', 'block');
                }
            }

            //更新已选中
            var num_iid = $(this).parents('tr').attr('data-num_iid');
            if ($(this).prop('checked') == true) {
                var item = Item.createNew(this)
                that.copytaobao_list.push(item)

            } else {
                for (var i = 0; i < that.copytaobao_list.length; i++) {
                    if (num_iid == that.copytaobao_list[i].id) {
                        that.copytaobao_list.splice(i, 1)
                    }
                }
            }
            $('#tab-five .JS_copy_checkbox_num').html(that.copytaobao_list.length)

            //	                that.updateShopGoodsCheckAllNums(num_iid, url, 'pop');
        });


        //单行选中
        $('#JS_taobao_goods_list').on('click', 'tr', function(e) {
                if ($(e.target).prop('tagName') == 'DIV' || $(e.target).prop('tagName') == 'TD') {
                    if ($(this).find('.JS_copy_checkbox').prop('checked') == true) {
                        $(this).find('.checkbox-pretty').checkbox().checkbox('uncheck')
                    } else {
                        $(this).find('.checkbox-pretty').checkbox().checkbox('check')
                    }

                }
            })
            //复制店铺table的单行选中
        $('#JS_shop_goods_list').on('click', 'tr', function(e) {
                if ($(e.target).prop('tagName') == 'DIV' || $(e.target).prop('tagName') == 'TD') {
                    if ($(this).find('.JS_copy_checkbox').prop('checked') == true) {
                        $(this).find('.checkbox-pretty').checkbox().checkbox('uncheck')
                    } else {
                        $(this).find('.checkbox-pretty').checkbox().checkbox('check')
                    }

                }
            })
            //复制单个
        $('#tab-five').on('click', '.JS_copy', function() {
            var tr = $(this).closest('tr')
            var url = $(tr).attr('data-url')
            var params = that.getTaobaoGoodsParams(url);
            var item = Item.createNew(this)
            item.update()
            ajax('/copy_goods/ajax_save_copy', params, function(res) {
                if (res.status == 'FAIL') {
                    showErrorNotice(res.msg)
                    item.show()
                }
            })
        })

        // 复制选中
        $('#tab-five').on('click', '.js_copy_checked', function() {
            var urls = [];
            if (that.copytaobao_list.length < 1) {
                that.dialog('fail', '请先勾选复制宝贝', '', '', '知道了', '', '错误提示');
            } else {
                $.each(that.copytaobao_list, function(index, item) {
                    urls.push(item.url);
                });
                urls = urls.join("\r");
                that.checkUrl(urls, function() {
                    var params = that.getTaobaoGoodsParams(urls);
                    var len = that.copytaobao_list.length - 1
                    for (var i = len; i >= 0; i--) {
                        that.copytaobao_list[i].update()
                    }
                    ajax('/copy_goods/ajax_save_copy', params, function(res) {
                        if (res.status == 'OK') {
                            that.dialog('nobtn', "宝贝已经转入后台复制中，预计需要一段时间，请稍候在“复制记录”中查看！");
                        } else if (res.status == 'COPY_UPGRADE') {
                            $('#copy-upgrade .upgradeModal-text').html(res.msg);
                            $('#copy-upgrade').modal('show');
                        } else {
                            that.dialog('fail', res.msg, '', '', '知道了', '', '错误提示');
                        }
                    })



                }, 1);
            }
        });

        // 复制本页
        $('#tab-five').on('click', '.JS_copy_page', function() {
            var urls = []
            var params_url = []
            var msg = ''
            $('#JS_taobao_goods_list .JS_copy').each(function() {
                var item = Item.createNew(this)
                urls.push(item.url)
                params_url.push(item.url)
                item.update()
            })
            urls = urls.join("\r");
            var params = that.getTaobaoGoodsParams(urls)

            msg = "<span style='color:red'>确定将" + params_url.length + "个宝贝复制到指定类目？</span><br>";

            msg = msg + "<span style='color:#999;'>本月复制数量用完后，超出部分将不会被复制。</span>";

            window.copy_goods.dialog('confirm', msg, function() { //确定
                bigLoading();
                ajax('/copy_goods/ajax_save_copy', params, function(data) {
                    closeBigLoading();
                    if (data.status == 'OK') {
                        that.dialog('nobtn', "宝贝已经转入后台复制中，预计需要一段时间，请稍候在“复制记录”中查看！");
                    } else {
                        if (data.status == 'COPY_UPGRADE') {
                            $('#copy-upgrade .upgradeModal-text').html(data.msg);
                            $('#copy-upgrade').modal('show');
                        } else {
                            that.dialog('fail', data.msg, '', '', '知道了', '', '错误提示');
                        }
                    }
                });
            }, function() {}, '确定', '取消');
        });

        //设置复制前多少个宝贝
        $('.js_copy_count').tooltip({
            animation: false,
            type: 'confirm',
            okHide: function() {
                $('.copy_count_num').html($('.count_num').val())
                this.tooltip('hide')
            },
            hide: function() {
                console.log(this)
            }
        })

        //
        $('body').on('input', '.count_num', function() {
            if ($(this).val() === '0') {
                $(this).val(200)
            } else {
                $(this).val($(this).val().replace(/[^0-9]+/g, ''))
            }


        });
        //复制前200的宝贝
        $('.JS_copy_200').click(function() {
            if (!checkCopy()) {
                var count_num = $('.copy_count_num').html()
                var msg = ''
                msg = "<span style='color:red'>确定将" + count_num + "个宝贝复制到指定类目？</span><br>";
                msg += "<span style='color:#999;'>本月复制数量用完后，超出部分将不会被复制。</span>";

                window.copy_goods.dialog('confirm', msg, function() { //确定
                    bigLoading();
                    var params = that.getTaobaoGoodsParams()
                    params.keyword = params_copy_taobao_list.keyword
                    params.baoyou = params_copy_taobao_list.baoyou
                    params.filter_tianmao = params_copy_taobao_list.filter_tianmao
                    params.auction_tag = params_copy_taobao_list.auction_tag
                    params.reserve_price_start = params_copy_taobao_list.reserve_price_start
                    params.reserve_price_end = params_copy_taobao_list.reserve_price_end
                    params.sort = params_copy_taobao_list.sort
                    params.task_num = count_num
                    ajax('/copy_goods/ajax_add_search_taobao_copy_task', params, function(data) {
                        closeBigLoading();
                        if (data.status == 'OK') {
                            that.dialog('nobtn', "宝贝已经转入后台复制中，预计需要一段时间，请稍候在“复制记录”中查看！");
                        } else {
                            if (data.status == 'COPY_UPGRADE') {
                                $('#copy-upgrade .upgradeModal-text').html(data.msg);
                                $('#copy-upgrade').modal('show');
                            } else that.dialog('fail', data.msg, '', '', '知道了', '', '错误提示');
                        }
                    });
                }, function() {}, '确定', '取消');
            }
        })

        //检验是否能否复制
        var checkCopy = function() {
                var month_rest = Number($('.month_rest').text());

                var free_warning_msg = '免费版不支持复制全店，请升级';

                if (global_data.version_no <= 1) { //免费版 不支持复制全店
                    that.dialog('fail', free_warning_msg, function() {
                        $('#copy-upgrade .upgradeModal-text').html(free_warning_msg);
                        $('#copy-upgrade').modal('show');
                    }, '', '立即升级', '', '请升级');
                    return false;
                }
                if (month_rest <= 0) {
                    msg = "<br />您本月复制宝贝数量已用完，如果还需要复制更多请升级。";
                    that.dialog('fail', msg, '', '', '知道了', '', '错误提示');
                    return false
                }
            }
            /*暂用此地结束*/
    };
    //版式类(item的构造函数，传入所在行的任意dom)
    var Item = {
        createNew: function(dom) {
            var item = {};

            //获取商品正行tr的dom
            item._dom = $(dom).closest('tr')

            //获取商品的id
            item.id = item._dom.attr('data-num_iid')

            //商品的状态
            item.url = item._dom.attr('data-url')

            //根据状态修改itemUi
            item.show = function() {
                item._dom.find('.tip-hover').addClass('hide')
                item._dom.find('.JS_copy').show()
                item._dom.find('.checkbox-pretty').checkbox().checkbox('uncheck')
                item._dom.find('.checkbox-pretty').checkbox().checkbox('enable')
            }
            item.update = function() {
                item._dom.find('.tip-hover').removeClass('hide')
                item._dom.find('.JS_copy').hide()
                item._dom.find('.checkbox-pretty').checkbox().checkbox('uncheck')
                item._dom.find('.checkbox-pretty').checkbox().checkbox('disable')
            }
            return item;
        }
    }
    this.getTaobaoGoodsParams = function(urls) {
        var params = that.getParams(urls, 3);
        return params;
    }

    this.emptyChangeParams = function() {
        that.change_log_ids = new Array;
        that.change_record_ids = new Array;
        that.change_created_ats = new Array;
    }

    this.showChangeProps = function(props) {
        var html = '';
        for (k in props) {
            props[k] = $.trim(props[k]);
        }
        $.unique(props.sort());
        for (k in props) {
            html += '<div class="list-attr">' + '<div class="control-group">' + '<label class="control-label">*' + props[k] + '：</label>' + '<div class="controls">' + '<input type="hidden" class="input-name" value="' + props[k] + '">' + '<input class="input-text" type="text" />' + '</div>' + '</div>' + '</div>';
        }
        return html;
    }

    this.setCatsSearch = function() {
        $('body').on('click', '.1688cats li', function() {
            var is_parent = $(this).attr('is_parent');
            var level = $(this).closest('.1688cats').index('.1688cats');
            var parent_cid = $(this).attr('value');
            $(this).closest('.1688cats').find('.JS_cid').prop('cid', parent_cid);
            if (parent_cid == '0') {
                $(this).closest('.1688cats').find('.JS_cid').val('');
                $(".category_tips").hide();
            } else $(".category_tips").show();
            if (is_parent == 'true') {
                that.getTaobaoCategory(parent_cid, level + 1);
            } else {
                $('.1688cats:gt(' + level + ')').remove();
            }
        })

        $('body').on("keyup", ".combo-input", function() { //查找
            var the = $(this);
            var val = $.trim(the.val()).toLowerCase();
            var flag = '_flag'
            clearTimeout(that.flag);
            that.flag = setTimeout(function() {
                that.searchInfo(the, val);
            }, 500);
        })
    }

    // update shop goods checkall nums(更新已选中)
    this.updateShopGoodsCheckAllNums = function(num_iid, url, push_or_pup) {
        if (push_or_pup == 'push') {
            that.copyshop_list[num_iid] = url;
        } else {
            delete that.copyshop_list[num_iid];
        }
        copyshop_list_length = 0;
        for (var item in that.copyshop_list) copyshop_list_length++;
        $('#tab-two .JS_copy_checkbox_num').html(copyshop_list_length);
    };

    // submit copy form
    this.submitCopyForm = function() {
        var urls = $("#tab-one .JS_urls").val();
        var params = that.getParams(urls, 1);
        if (!params) {
            return false;
        }

        bigLoading();
        ajax('/copy_goods/ajaxSaveCopy', params, function(data) {
            if (data.status == 'OK') {
                $('#tab-one .JS_urls').val('');
                that.dialog('nobtn', data.msg);
            } else if (data.status == 'FAIL') {
                that.dialog('fail', data.msg, '', '', '知道了', '', '复制失败');
            } else if (data.status == 'COPY_UPGRADE') {
                $('#copy-upgrade .upgradeModal-text').html(data.msg);
                $('#copy-upgrade').modal('show');
            }
        });
    };

    /**
     * @Author   Liu
     * @DateTime 2017-11-30
     * @param    {[type]}   url       [description]
     * @param    {[type]}   copy_type 1输入链接复制  2店铺复制 3复制淘宝精品
     * @return   {[type]}             [description]
     */
    this.getParams = function(urls, copy_type) {
        //类目
        var category = $(".category").val();
        var category_name = $(".category").closest('a').find('span').html();

        //标题
        var prefix = $(".prefix").val();
        var suffix = $(".suffix").val();

        //过滤标题关键词
        var remove_title_key = $('.remove_title_key').hasClass('checked') ? 1 : 0;
        //替换标题关键词
        var replace_title_key = $('.replace_title_key').hasClass('checked') ? 1 : 0;
        //排除 标题含关键词
        var exclude_title_key = $('.exclude_title_key').hasClass('checked') ? 1 : 0;

        //价格
        var price_type = $(".JS_price_type").val();
        var price_mult_float = $('.price_mult_float').val();
        var price_change = $('.JS_price_change').val();
        //主图
        var image_num = $(".image_num").val();
        var image_type = $(".JS_image_type").val();
        var image_type_name = $(".JS_image_option_title").html();

        //详情
        //去掉模板
        var remove_temp = $(".remove_temp").hasClass('checked') ? 1 : 0;
        //来源信息
        var show_from = $('.show_from').hasClass('checked') ? 1 : 0;
        //手机
        var mobile_desc_type = $(".JS_mobile_desc_type").val();
        //运费
        var freights = $(".JS_freights").val();
        var freights_name = $(".JS_shipping_option_title").html();
        //地址
        var location_type = $('.location_type').val();
        var state = $("#address1_state_input").val();
        var city = $("#address1_city_input").val();
        //容错设置
        var fault_tolerant = $(".fault_tolerant").hasClass('checked') ? 1 : 0;

        var del_repeat = $(".del_repeat").hasClass('checked') ? 1 : 0;
        //商家编码
        var set_outer_id = $(".set_outer_id").val();
        //自动上架
        //var auto_onsale = $(".auto_onsale").hasClass('checked') ? 1 : 0;
        var auto_onsale = $(".auto_onsale").val();
        var list_time = $(".list_time").val();
        var list_space = $(".list_space").val();
        if (auto_onsale == '2' && (!list_time || !list_space)) {
            showErrorNotice('请设定上架时间', true);
            return false;
        }

        //修改属性
        var change_props = $(".change_props").hasClass('checked') ? 1 : 0;
        var change_props_input = $('.change_props_input').val();

        //抹零设置
        var price_zero = $(".price_zero").val();

        //图片盾
        var image_sheild = $('.image_sheild').val();

        //自动关联同步
        var sync_relation = $('.sync_relation').hasClass('checked') ? 1 : 0;

        //主图处理
        var image_set = $('.image_set').val();

        //过滤卖点
        var remove_sell_point = $(".remove_sell_point").hasClass('checked') ? 1 : 0;

        //极速发布
        var fast_copy = $(".fast_copy").hasClass('checked') ? 1 : 0;

        //过滤品牌
        var filter_brand = $(".filter_brand").hasClass('checked') ? 1 : 0;
        //过滤店铺
        var filter_shop = $(".filter_shop").hasClass('checked') ? 1 : 0;

        //------详情设置------
        //去掉详情图片
        var remove_pic = $(".remove_pic").hasClass('checked') ? 1 : 0;
        var asc_num = $('.asc_num').val(); //头部 图片
        var desc_num = $('.desc_num').val(); //尾部 图片
        var remove_url = $(".remove_url").hasClass('checked') ? 1 : 0; //去掉指定url图片
        var remove_word = $(".remove_word").hasClass('checked') ? 1 : 0; //去掉详情文字
        var remove_urlpic = $(".remove_urlpic").hasClass('checked') ? 1 : 0; //去掉带链接图文

        var cid = $(".JS_cid:last").prop('cid');
        if (!cid && $(".JS_cid").length > 1) {
            showErrorNotice('请选择完整类目', true);
            return false;
        }

        if (copy_type == '2') {
            var shop_type = $('.JS_shop_type').val();
            var alibaba = shop_type == 2 ? 1 : 0;
            if (alibaba && !cid) {
                showErrorNotice('请选择淘宝类目', true);
                return false;
            }
        } else if (copy_type == '1') {
            var res = that.checkUrlInfo(urls, cid);
            if (!res) return false;
        }

        var taobao_category = new Array;
        var taobao_category_name = new Array;
        if (cid) {
            $('.JS_cid').each(function() {
                if ($(this).prop('cid') && $(this).val()) {
                    taobao_category.push($(this).prop('cid'));
                    taobao_category_name.push($(this).val());
                }
            })
        }

        var params = {
            urls: urls,
            category: category,
            category_name: category_name,
            prefix: prefix,
            suffix: suffix,
            remove_title_key: remove_title_key,
            replace_title_key: replace_title_key,
            exclude_title_key: exclude_title_key,
            price_type: price_type,
            price_mult_float: price_mult_float,
            price_change: price_change,
            image_num: image_num,
            image_type: image_type,
            image_type_name: image_type_name,
            remove_temp: remove_temp,
            show_from: show_from,
            mobile_desc_type: mobile_desc_type,
            freights: freights,
            freights_name: freights_name,
            location_type: location_type,
            state: state,
            city: city,
            fault_tolerant: fault_tolerant,
            del_repeat: del_repeat,
            set_outer_id: set_outer_id,
            auto_onsale: auto_onsale,
            list_time: list_time,
            list_space: list_space,
            change_props: change_props,
            change_props_input: change_props_input,
            price_zero: price_zero,
            copy_type: copy_type,
            cid: cid,
            taobao_category: taobao_category,
            taobao_category_name: taobao_category_name,
            image_sheild: image_sheild,
            sync_relation: sync_relation,
            image_set: image_set,
            remove_sell_point: remove_sell_point,
            fast_copy: fast_copy,
            filter_brand: filter_brand,
            filter_shop: filter_shop,
            remove_pic: remove_pic,
            asc_num: asc_num,
            desc_num: desc_num,
            remove_url: remove_url,
            remove_word: remove_word,
            remove_urlpic: remove_urlpic,
        };

        if (copy_type == '2') {
            params.shop_type = shop_type;
            params.alibaba = alibaba;
        }

        return params;
    }

    //过滤店铺
    this.filterShop = function() {
        var shop_name = $('#tab-two .JS_search_nick').data('shop_name');
        var filter_shop = $(".filter_shop").hasClass('checked') ? 1 : 0;
        var result = {
            'status': 'FAIL'
        };
        if (filter_shop && shop_name) {
            ajax('/copy_goods/ajaxFilterShop', {
                shop_name: shop_name
            }, function(data) {
                result = data;
            }, '', '', false)
        }
        return result;
    }

    // reset submit input
    this.submitInputReset = function() {
        $('.JS_title').val('');
        $(".JS_status_options li a[value='']").trigger('click');
    };

    this.checkUrlInfo = function(urls, cid) {
        var res = true;
        ajax('/copy_goods/ajaxCheckUrl', {
            urls: urls
        }, function(data) {
            if (data.status == 'OK') {
                var url_info = data.url_info;
                if (url_info.alibaba > 0 && !cid) { //存在alibaba宝贝，类目未选
                    $("#tab-one .JS_url_error").html('存在阿里巴巴宝贝，请选择类目');
                    $("#tab-one .JS_urls").parent().addClass('textarea-error');
                    res = false;
                }
                if (url_info.jd > 0 && !cid) { //存在alibaba宝贝，类目未选
                    $("#tab-one .JS_url_error").html('存在京东宝贝，请选择类目');
                    $("#tab-one .JS_urls").parent().addClass('textarea-error');
                    res = false;
                }
            } else if (data.status == 'COPY_UPGRADE') {
                $('#copy-upgrade .upgradeModal-text').html(data.msg);
                $('#copy-upgrade').modal('show');
                res = false;
            } else {
                $("#tab-one .JS_url_error").html(data.msg);
                $("#tab-one .JS_urls").parent().addClass('textarea-error');
                res = false;
            }
        }, '', '', false);
        return res;
    }

    // check urls
    this.checkUrl = function(urls, callback, shop) {
        var shop = arguments[2] ? arguments[2] : 0;
        ajax('/copy_goods/ajaxCheckUrl', {
            urls: urls,
            shop: shop
        }, function(data) {
            if (data.status == 'OK') callback();
            else if (data.status == 'COPY_UPGRADE') {
                $('#copy-upgrade .upgradeModal-text').html(data.msg);
                $('#copy-upgrade').modal('show');
            } else {
                $("#tab-one .JS_url_error").html(data.msg);
                $("#tab-one .JS_urls").parent().addClass('textarea-error');
            }
        });
    };

    this.check1688Url = function(urls, callback) {
        ajax('/copy_goods/ajaxCheck1688Url', {
            urls: urls
        }, function(data) {
            if (data.status == 'OK') callback();
            else if (data.status == 'COPY_UPGRADE') {
                $('#copy-upgrade .upgradeModal-text').html(data.msg);
                $('#copy-upgrade').modal('show');
            } else {
                $("#tab-five .JS_url_error").html(data.msg);
                $("#tab-five .JS_urls").parent().addClass('textarea-error');
            }
        });
    };

    this.getCategoryOption = function() {
        if (!$('.category_option li').length) {
            var category = $('.category').val();
            ajax('/copy_goods/ajax_get_category', {}, function(data) {
                $('.category_option').html(data.list_html);
            }, '', '', false);
            // if( category ){
            $(".category_option li a[value='" + category + "']").trigger('click');
            // }
        }
    }

    this.getImageOption = function() {
        if (!$('.JS_image_option li') || !$('.JS_image_option li').length) {
            var image_type = $('.JS_image_type').val();
            var image_type_name = $('.JS_image_option_title').html();
            ajax('/copy_goods/ajax_get_image_option', {}, function(data) {
                var list = "";
                $.each(data.list, function(i, n) {
                    if (i == 0) {
                        $('.JS_image_type').val(n.picture_category_id);
                        $('.JS_image_option_title').html(n.picture_category_name);
                    }
                    list = list + "<li role=\"presentation\"" + (i == 0 ? " class=\"active\"" : '') + " ><a role=\"menuitem\" tabindex=\"-1\" href=\"javascript:void(0);\" value=\"" + n.picture_category_id + "\">" + n.picture_category_name + "</a></li>";
                });
                $('.JS_image_option').html(list);
            }, '', '', false);
            if (image_type) {
                $(".JS_image_option li a[value='" + image_type + "']").trigger('click');
            }
        }
    }

    this.getShippingOption = function() {
        if (!$('.JS_shipping_option li') || !$('.JS_shipping_option li').length) {
            var freights = $('.JS_freights').val();
            ajax('/copy_goods/ajax_get_shipping_option', {}, function(data) {
                var list = "<li role=\"presentation\" class=\"active\"><a role=\"menuitem\" tabindex=\"-1\" href=\"javascript:void(0);\" value=\"\">不设置运费模板</a></li>";
                list += "<li role=\"presentation\" class=\"active\"><a role=\"menuitem\" tabindex=\"-1\" href=\"javascript:void(0);\" value=\"-1\">复制来源宝贝运费模板</a></li>";
                $.each(data.list, function(i, n) {
                    list = list + "<li role=\"presentation\"><a role=\"menuitem\" tabindex=\"-1\" href=\"javascript:void(0);\" value=\"" + n.template_id + "\">" + n.name + "</a></li>";
                });
                $('.JS_shipping_option').html(list);
            }, '', '', false);
            // if( freights ){
            $(".JS_shipping_option li a[value='" + freights + "']").trigger('click');
            // }
        }
    }

    //复制页面 初始化
    this.copyInfoInit = function() {
        ajax('/copy_goods/ajax_copy_info_init', {}, function(data) {
            if (data.show_notice) {
                $('.show_notice').show();
            }
            if (data.num_info) {
                //$('.JS_month_copyed_count').html(data.num_info.month_num);
                var num_info = data.num_info;
                $('.month_cost').html(num_info.total);
                $('.month_rest').html(num_info.rest);
                $('#rest_info').attr('data-original-title', num_info.rest_content);
                $('#rest_info').closest('a').show();
            }
            if (data.day <= 20) {
                $('.day_warning .day').html(data.day);
                $('.day_warning').show();
            }

            if (data.api_limit) {
                $('.show-limit-msg').show();
            } else {
                $('.show-limit-msg').hide();
            }
            if (data.default_set.status == 'OK') {
                //默认设置
                var default_set = data.default_set.msg;

                //价格
                $(".JS_price_type_option li a[value='" + default_set.price_type + "']").trigger('click');
                $(".price_mult_float_option li a[value='" + default_set.price_mult_float + "']").trigger('click');
                $(".JS_price_change").val(default_set.price_change);
                $(".price_zero_option li a[value='" + default_set.price_zero + "']").trigger('click');

                //标题
                $('.prefix').val(default_set.prefix);
                $('.suffix').val(default_set.suffix);

                if (default_set.remove_title_key == '1') {
                    $('.remove_title_key').removeClass('checked').addClass('checked');
                } else {
                    $('.remove_title_key').removeClass('checked');
                    $('.remove_title_key input').removeAttr('checked');
                }
                if (default_set.replace_title_key == '1') {
                    $('.replace_title_key').removeClass('checked').addClass('checked');
                } else {
                    $('.replace_title_key').removeClass('checked');
                }

                //主图
                $(".image_num_option li a[value='" + default_set.image_num + "']").trigger('click');
                //主图处理
                $(".image_set_option li a[value='" + default_set.image_set + "']").trigger('click');

                //location
                $(".location_type_option li a[value='" + default_set.location_type + "']").trigger('click');
                $("#address1_state li a[value='" + default_set.location_state + "']").trigger('click');
                $("#address1_city li a[value='" + default_set.location_city + "']").trigger('click');

                //过滤
                if (default_set.del_repeat == '1') {
                    $('.del_repeat').removeClass('checked').addClass('checked');
                } else {
                    $('.del_repeat').removeClass('checked');
                    $('.del_repeat input').removeAttr('checked');
                }
                if (default_set.exclude_title_key == '1') {
                    $('.exclude_title_key').removeClass('checked').addClass('checked');
                } else {
                    $('.exclude_title_key').removeClass('checked');
                }
                //过滤店铺
                if (default_set.filter_shop == '1') {
                    $('.filter_shop').removeClass('checked').addClass('checked');
                } else {
                    $('.filter_shop').removeClass('checked');
                }
                //过滤品牌
                if (default_set.filter_brand == '1') {
                    $('.filter_brand').removeClass('checked').addClass('checked');
                } else {
                    $('.filter_brand').removeClass('checked');
                }

                //手机详情
                $(".JS_mobile_desc_type_option li a[value='" + default_set.mobile_desc_type + "']").trigger('click');

                //图片目录  只显示默认值  点击ajax加载选项
                $('.JS_image_type').val(default_set.image_type);
                if (!default_set.image_type_name) { //兼容原数据
                    that.getImageOption();
                } else {
                    $('.JS_image_option_title').html(default_set.image_type_name);
                }

                //详情
                if (default_set.remove_temp == '1') {
                    $('.remove_temp').removeClass('checked').addClass('checked');
                } else {
                    $('.remove_temp').removeClass('checked');
                    $('.remove_temp input').removeAttr('checked');
                }
                if (default_set.remove_pic == '1') {
                    $('.remove_pic').removeClass('checked').addClass('checked');
                } else {
                    $('.remove_pic').removeClass('checked');
                }
                $('.asc_num').val(default_set.asc_num);
                $('.desc_num').val(default_set.desc_num);

                if (default_set.remove_url == '1') {
                    $('.remove_url').removeClass('checked').addClass('checked');
                } else {
                    $('.remove_url').removeClass('checked');
                }
                if (default_set.remove_word == '1') {
                    $('.remove_word').removeClass('checked').addClass('checked');
                } else {
                    $('.remove_word').removeClass('checked');
                }
                if (default_set.remove_urlpic == '1') {
                    $('.remove_urlpic').removeClass('checked').addClass('checked');
                } else {
                    $('.remove_urlpic').removeClass('checked');
                }

                //店铺分类
                $('.category').val(default_set.category);
                var category_name = default_set.category_name ? default_set.category_name : '请选择类目';
                $('.category_option_title').html(category_name);

                //运费
                $('.JS_freights').val(default_set.freights);
                if (!default_set.freights_name) {
                    that.getShippingOption();
                } else {
                    $('.JS_shipping_option_title').html(default_set.freights_name);
                }

                //来源
                if (default_set.show_from == '1') {
                    $('.show_from').removeClass('checked').addClass('checked');
                } else {
                    $('.show_from').removeClass('checked');
                }

                //商家编码
                $(".set_outer_id_option li a[value='" + default_set.set_outer_id + "']").trigger('click');

                //容错
                if (default_set.fault_tolerant == '1') {
                    $('.fault_tolerant').removeClass('checked').addClass('checked');
                } else {
                    $('.fault_tolerant').removeClass('checked');
                }

                //修改属性
                if (default_set.change_props == '1') {
                    $('.change_props').removeClass('checked').addClass('checked');
                } else {
                    $('.change_props').removeClass('checked');
                }
                $('.change_props_input').val(default_set.change_props_input);

                //自动上架
                $(".auto_onsale_option li a[value='" + default_set.auto_onsale + "']").trigger('click');
                $(".list_time").val(default_set.list_time);
                $(".list_space").val(default_set.list_space);

                //图片盾
                $(".image_sheild_option li a[value='" + default_set.image_sheild + "']").trigger('click');

                //自动关联
                if (default_set.sync_relation == '1') {
                    $('.sync_relation').removeClass('checked').addClass('checked');
                } else {
                    $('.sync_relation').removeClass('checked');
                }

                //极速复制
                if (default_set.fast_copy) {
                    $('.fast_copy').removeClass('checked').addClass('checked');
                } else {
                    $('.fast_copy').removeClass('checked');
                }

                //淘宝类目
                // default_set.taobao_category
                // default_set.taobao_category_name
                var cat_clone;
                if (default_set.taobao_category) {
                    $.each(default_set.taobao_category, function(level, v) {
                        if (level > 0) {
                            cat_clone = $('.1688cats:last').clone()
                            $('.1688cats:last').after(cat_clone);
                        }
                        $('.1688cats:eq(' + level + ')').find('.JS_cid').prop('cid', v);
                        $('.1688cats:eq(' + level + ')').find('.JS_cid').val(default_set.taobao_category_name[level]);
                    })
                }
            } else {
                $('.category_option_title').html('请选择类目');
                $('.JS_image_option_title').html('智淘商品复制宝贝素材_勿删');
                that.getImageOption();
                $('.JS_shipping_option_title').html('不设置运费模板');
            }

            if (data.keys.status == 'OK') {
                $('#title_keys_content').html(data.keys.keys1);
                $('#exclude_title_keys_content').html(data.keys.keys2);
                if (data.keys.keys3) {
                    var keys = JSON.parse(data.keys.keys3);
                    var k = 0;
                    $.each(keys, function(i, v) {
                        $('#replaceTitleKeys [name="source[]"]').eq(k).val(i);
                        $('#replaceTitleKeys [name="change[]"]').eq(k).val(v);
                        k++;
                    })
                }
            }

            // if( data.taobao_category.status == 'OK'){
            // 	cats_content[0] = data.taobao_category.cats;
            // 	that.getTaobaoCategory('','');
            // }
        })

        $('body').on('click', '.dyn_load', function() {
            var name = $(this).closest('div').prev('label').html();
            name = name.replace('：', '');

            switch (name) {
                case '店铺分类':
                    that.getCategoryOption();
                    break;
                case '图片目录':
                    that.getImageOption();
                    break;
                case '运费设置':
                    that.getShippingOption();
                    break;
            }
        })

        //加载淘宝类目
        $('body').on('click', '.JS_cid', function(event) {
            var content = $(this).closest('.1688cats');
            if (!content.find('ul.combo-ul li.option-item').length) {
                event.stopPropagation();
                var level = content.index('.1688cats'); //当前等级
                var parent_cid = ''; //上一级id
                if (level > 0) {
                    parent_cid = $('.1688cats').eq(level - 1).find('.JS_cid').prop('cid');
                }
                var cid = $(this).prop('cid');
                that.getTaobaoCategory(parent_cid, level, cid);
            }
        })

        $('body').on('click', '.combo-arrow', function(event) {
            event.stopPropagation();
            $(this).prev('input').trigger('click');
        })
    }

    // 过滤信息初始化
    this.initFilterMsg = function() {
        ajax('/copy_goods/ajax_get_filter', {
            type: 'all'
        }, function(res) {

            $('#brands_content').val(res.brand.join(','))
            $('#urls_content').val(res.url.join('\n'))
            $('#shop_names_content').val(res.shop.join('\n'))
        })
    }

    // 自动上架
    this.onsaleTime = function(start, end) {
        // $('#id-input-time').val(start + ' - ' + end)
        // var end = moment()
        $('#onsale_time').daterangepicker({
            singleDatePicker: true,
            timePicker: true,
            timePickerIncrement: 1,
            format: 'YYYY-MM-DD HH:mm',
            timePicker12Hour: false,
            opens: 'right',
            showDropdowns: true,
            showWeekNumbers: true,
            // startDate: start,
            // endDate: end,
            minDate: moment(),
            locale: {
                //applyLabel: 'Submit',
                //cancelLabel: 'Clear',
                // fromLabel: '开始',
                // toLabel: '结束',
                customRangeLabel: '自定义',
                daysOfWeek: ['日', '一', '二', '三', '四', '五', '六'],
                monthNames: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月'],
                // firstDay: 1,
            }
        });
        $('body').on('change', '.auto_onsale', function() {
            var val = $(this).val()
            if (val == 1) {
                $('.auto_onsale_tip').show()
                $('.onsale_time_span').hide()
            } else if (val == 2) {
                $('.onsale_time_span').show()
                $('.auto_onsale_tip').hide()
            } else {
                $('.auto_onsale_tip').hide()
                $('.onsale_time_span').hide()
            }

        })

        $('body').on('input propertychange change', '#wait_time', function(event) {
            var val = $(this).val().replace(/[^0-9]+/g, '')
            if (val > 60) {
                $(this).val(60)
            } else if (parseInt(val) === 0) {
                $(this).val(1)
            } else {
                $(this).val(val)
            }
        });
    }

    // 详情设置
    this.setDetail = function() {
        $('body').on('input propertychange change', '.asc_num', function(event) {
            var val = $(this).val().replace(/[^0-9]+/g, '')
            if (parseInt(val) === 0) {
                $(this).val(1)
            } else {
                $(this).val(val)
            }
        })
        $('body').on('input propertychange change', '.desc_num', function(event) {
            var val = $(this).val().replace(/[^0-9]+/g, '')
            var val = $(this).val().replace(/[^0-9]+/g, '')
            if (parseInt(val) === 0) {
                $(this).val(1)
            } else {
                $(this).val(val)
            }
        })
    }

    this.showShopMsg = function() {
        if (global_data.user == undefined) {
            return;
        }

        if (global_data.user.type == 'B') {
            $('#tab-two .JS_search_nick').attr('placeholder', '请输入天猫店铺卖家旺旺');
            $('#tab-two .show_alibaba').hide();
        } else {
            $('#tab-two .JS_search_nick').attr('placeholder', '请输入卖家旺旺或阿里巴巴店铺网址');
            $('#tab-two .show_alibaba').show();
        }
        clearInterval(showshopmsg_interval);
    }

    this.showName = function() {
        if (global_data.user == undefined) {
            return;
        }
        if (global_data.user.type == 'C') {
            $('.tab_one_name').html('复制淘宝/天猫/阿里巴巴/京东');
            $('.JS_urls').attr('placeholder', "请输入淘宝/天猫/阿里巴巴的宝贝链接地址，例如：https://item.taobao.com/item.htm?spm=a230r.1.14.216.IWZNG2&id=000000000000，支持批量输入连接，请以回车换行区分。");
            $('.auto_relation').show();
        } else {
            $('.tab_one_name').html('复制天猫');
            $('.JS_urls').attr('placeholder', "请输入天猫的宝贝链接地址，例如：https://detail.tmall.com/item.htm?id=000000000000，支持批量输入连接，请以回车换行区分。");
            $('.auto_relation').hide();
        }
        clearInterval(showname_interval);
    }

    this.initUpdateConfig = function() {
        if (global_data.update_config == undefined) {
            return;
        }

        // var update_config_json = JSON.parse(global_data.update_config);
        //
        // //当前版本配置
        // var now_version = update_config_json[global_data.version_no];
        // if (!now_version) {
        //     now_version = {};
        //     now_version.month_limit = 3;
        // }
        // $('.limit').html(now_version.month_limit);
        // moredata_interval = setInterval(that.moreDataShow, 50);

        if (global_data.version_no < 3) {
            $('.show_update_tab').show();
        }

        that.copyUpdate(global_data.update_config, global_data.version_no);
        // copyUpdate(global_data.update_config,global_data.version_no);
        if (global_data.renew_config) {
            var renew_json = JSON.parse(global_data.renew_config);
            var config = renew_json[global_data.version_no];
            var modal = $('#index-xufei');
            modal.find('.modal-body').find('span span').html(global_data.invalidated_at);
            modal.find('.version-text').find('span').html(config.name);

            var advanced = config['advanced'];
            var li = '';
            for (i in advanced) {
                li += '<li>';
                li += '<div class="ver-mouth">' + advanced[i].name + '</div>';
                li += '<div class="ver-zk';
                if (i == 12) li += ' red-price';
                li += '">' + advanced[i].price + '元</div>';
                li += '<div class="ver-price">' + advanced[i].o_price + '元</div>';
                li += '<a class="ver-btn new-btn" href="' + advanced[i].url + '">立即续费</a>';
                li += '</li>';
            }
            modal.find('.ver-list').find('ul').html(li);
            if (global_data.show_xufei) modal.modal('show');
        }
        if (global_data.version_no == 1) {
            $('#up-modal').show();
        }
        that.loadBanner();
        clearInterval(init_interval);
    };

    this.moreDataShow = function() {
        var month_num = $('.JS_month_copyed_count').text();
        if (!parseInt(month_num)) {
            return;
        }
        var month_limit = $('.limit').text();
        if (month_num / month_limit >= 0.8) {
            $('.JS_month_copyed_count').css('color', 'red');
            $('.more_traffic').show();
        }
        clearInterval(moredata_interval);
    }

    this.getCommon = function() {
        window.home = {};
        ajax('/home/common', '', function(data) {
            if (data.status == 'OK') {
                home.common = $.extend(home.common, data);
                $('.js_nick').html(home.common.user.nick);
                $('.js_version').html(home.common.user.version);
                $('.js_day').html(home.common.user.day);
                $('.js_invalidated_at').html(home.common.user.js_invalidated_at);
                if (home.common.user.version_no == 1) {
                    $('.js_version_1').show();
                }

                if (home.common.user.version_no > 3 && home.common.user.day < 85) {
                    $('.js_version_3_85').show();
                }

                if (home.common.upgrade_discount) {
                    var innerHtml = '';
                    $.each(home.common.upgrade_discount.promotion, function(k, v) {
                        innerHtml += '<a href="' + v.url + '"><div class="index-dialog-t"><i class="sui-icon icon-pc-sound"></i><span class="if_upgrade_discount_title">' + home.common.upgrade_discount.title + '</span><span class="if_upgrade_discount_desc">' + home.common.upgrade_discount.desc + '</span><div class="float-r acac js_left_time" ></div></div></a>';
                    });
                    $('.if_upgrade_discount').show().html(innerHtml);
                    home.count_down(home.common.upgrade_discount.end_time);
                }
                if (home.common.upgrade_default) {

                    var innerHtml = '';
                    $.each(home.common.upgrade_default.advanced, function(k, v) {
                        if (v.save) {
                            v.save = ' 省' + v.save + '元';
                        } else {
                            v.save = '';
                        }
                        innerHtml += '<span><a href="' + v.url + '" target="_blank">' + v.price + '元/' + v.type + v.save + '</a></span>';
                    });
                    $('.if_upgrade_default_list').html(innerHtml)
                    $('.if_upgrade_default').show();
                }
                (home.common.user.version < 3) && ($('.if_version_no').show());

                that.loadBanner();
                (home.common.user.day <= 10) && ($('.js_all_xufei').show());
            }
        });
    };

    this.loadBanner = function() {
        $.getScript('//cdn.promotion.dzsofts.net/js/modal.js?qntag=1', function() {
            $.getScript('//promotion.dzsofts.net/misc/activityNotice?aplication=qnitem&activity_notice=' + global_data.user.activity_notice + '&nick=' + global_data.user.nick + '&version_no=' + global_data.user.version_no + '&day=' + global_data.user.day, function() {
                ckSlide({
                    clas: '.focusmap',
                    autoPlay: true
                });
                var img = $('[src="https://img.alicdn.com/imgextra/i3/1204883/TB26g9OberAQeBjSZPcXXbJ6pXa-1204883.jpg"]');
                if (img.length > 0) {
                    img.parent().attr('href', 'javascript:;').attr('target', '');
                    img.bind('click', function() {
                        $('#index-xufei').modal('show');
                    });
                }
            });
        });
    };

    // load copy_list
    this.loadCopyList = function(page, show_bigloading) {
        page = page == undefined ? 1 : page;
        var title = $('.JS_title').val();
        var status = $('.JS_status').val();
        var pagesize = $('.JS_pagesize').val();
        if (show_bigloading != undefined) bigLoading();
        ajax('/copy_goods/ajaxGetCopyList', {
            title: title,
            status: status,
            page: page,
            pagesize: pagesize
        }, function(data) {
            if (data.limit) $('.show-limit-msg').show();
            else $('.show-limit-msg').hide();
            if (data.status == 'OK') {
                $(".JS_copy_list").html(data.list).removeClass('hide');
                $(".JS_page").html(data.pageinfo.pagenav);
                $(".JS_quicknav").html(data.pageinfo.qianniuQuickNav);
                $('.JS_list_error').addClass('hide');
                if ($('.JS_menu .active a').html() == '复制记录')
                    $("html,body").animate({
                        scrollTop: 0
                    }, 0);
                that.check_copy_list_status();
                $(".JS_copy_list tr td[colspan$='2']").addClass("txt-center");
            } else if (data.status == 'FAIL') {
                $(".JS_copy_list").addClass('hide');
                $(".JS_page").html('');
                $(".JS_quicknav").html('');
                $('.JS_list_error').removeClass('hide').find('div').html(data.msg);
            }
            menuHover();
            closeBigLoading();
        }, 'POST', {
            'show_loading': 1
        });
    };

    this.loadAuthList = function(page) {
        page = page == undefined ? 1 : page;
        var pagesize = $('.auth_pagesize').val();
        ajax('/copy_goods/ajaxGetAuthList', {
            page: page,
            pagesize: pagesize
        }, function(data) {
            if (data.status == 'OK') {
                $(".auth_list").html(data.list).removeClass('hide');
                $('.auth_list_error').addClass('hide');
                if ($('.JS_menu .active a').html() == '授权复制') $(".box-contentauto").animate({
                    scrollTop: 0
                }, 0); //goto top
            } else if (data.status == 'FAIL') {
                $(".auth_copy_list").addClass('hide');
                $('.auth_list_error').removeClass('hide').find('div').html(data.msg);
            }
        }, 'POST');
    };

    this.showItemListNoResults = function(data) {

        $("#JS_shop_goods_list").addClass('hide'); //隐藏列表

        var error_msg = data.msg;
        if (data.error_code && data.error_code > 3)
            error_msg = data.error_msg;
        if (data.error_field != undefined && data.error_field == 'JS_search_nick') {
            $('.JS_search_nick_error').removeClass('hide').find('div').html(error_msg);
            $('#tab-two .JS_formlist').addClass('hide');
        } else {
            $(".JS_page_copy_shop").html(''); // 隐藏分页
            $(".JS_quicknav_copy_shop").html(''); // 隐藏分页
            $('.JS_list_error_copy_shop').removeClass('hide').find('div').html(error_msg);
        }
    }

    /// 打印商品列表
    this.showItemList = function(data) {
        // $('.auth-show').hide();
        var html = template('script-shop-goods-list', data);
        $('#JS_shop_goods_list').html(html);

        that.ajax_copyshop_list_tmp = {};
        $.each(that.copyshop_list, function(i, n) {
            that.ajax_copyshop_list_tmp[i] = n;
            $("#JS_shop_goods_list tr[data-num_iid='" + i + "'] .JS_copy_checkbox").parent().checkbox().checkbox('check');
        });
        $('#tab-two .JS_formlist').add(".formlist-top").removeClass('hide');


        $(".JS_page_copy_shop").html(data.pageinfo.pagenav);
        $(".JS_quicknav_copy_shop").html(data.pageinfo.qianniuQuickNav);
        $('.JS_list_error_copy_shop').addClass('hide');
        $('.script-show').show(); // 价格

        $('.JS_formlist-top').hide();
        $('.auth-show').hide();
        $('.onsale-show').show();

        $('#tab-two .JS_search_category_click').hide();
        $('#tab-two .JS_formlist-top').removeAttr('style').css('display', 'inline-block');


        $('.JS_formlist-top').show();
        // $('.JS_formlist-top .JS_onsale_type').closest('.select').hide(); // 隐藏在售、仓库

        var nick = $.trim($('#tab-two .JS_search_nick').val());
        $('#category_options').data('nick', nick); // 作用？

        if (data.shop_type != '2') {
            $('.script-show').show();
        }


        // 保存必要的信息，取分类会用到
        $("[name='shop_id']").val(data.shop_id);
        $("[name='shop_type']").val(data.shop_type);
        $("[name='shop_url']").val(data.shop_url);
        if (!$('#tab-two .JS_category').val()) { //全店宝贝数量
            $("[name='shopall_nums']").val(data.total);
        }

        $("#JS_shop_goods_list").removeClass('hide'); //显示列表
        $(".JS_copy_all").attr('data-total', data.total);
    }

    // search shop goods
    this.searchShopGoods = function(page) {
        $("html,body").animate({
            scrollTop: $("#JS_shop_goods_list").closest('table').offset().top - 70
        }, 100)
        $(".JS_formlist .JS_check_all").parent().checkbox().checkbox('uncheck');

        var nick = $.trim($('#tab-two .JS_search_nick').val());
        $('#tab-two .JS_search_nick').val(nick);
        $('#tab-two .JS_search_nick').data('shop_name', nick);

        var keyword = $('#tab-two .JS_search_keyword').val();
        var onsale = $('#tab-two .JS_onsale_type').val();
        var category = $('#tab-two .JS_category').val();
        var category_name = '';
        if (category) category_name = $('#tab-two .JS_category').closest('a').find('span').text();

        var low_price = $('#tab-two .JS_search_low_price').val();
        var high_price = $('#tab-two .JS_search_high_price').val();

        var min_store = $('#tab-two .JS_low_store').val();
        var max_store = $('#tab-two .JS_high_store').val();

        var is_xinpin = $('#tab-two .JS_is_xinpin').prop('checked');
        var development_version = $("[name=development_version]").val();
        var fail_times = $("[name='fail_times']").val();
        var alibaba_total_page = $("[name='alibaba_total_page']").val();
        var alibaba_shop_id = $("[name='alibaba_shop_id']").val();
        var alibaba_keyword = $("[name='alibaba_keyword']").val();

        var pattern = new RegExp("(http:\/\/|https:\/\/)(.*)\.1688\.com");
        var test = pattern.test(nick);
        if (test) { //1688
            if (global_data.user && global_data.user.type == 'B') {
                $('.JS_search_nick_error').removeClass('hide').find('div').html('输入的关键词无效，请输入正确的旺旺');
                $('#tab-two .JS_search_nick').val('');
                return false;
            } else {
                $('.taobao-msg').hide();
                $('.1688cat-content').css('display', 'block');
                $('#tab-two .JS_shop_type').val('2');
            }
        } else {
            if (global_data.user && global_data.user.type == 'B') {
                var is_not_tmall = false;
                ajax('/copy_goods/ajaxCheckTmallName', {
                    name: nick
                }, function(data) {
                    if (data.status != 'OK' || data.is_tmall != true) {
                        $('.JS_search_nick_error').removeClass('hide').find('div').html('请输入天猫店铺卖家旺旺');
                        is_not_tmall = true;
                    }
                }, '', '', false);
                if (is_not_tmall)
                    return false;
            }
            $('.taobao-msg').show();
            $('.1688cat-content').css('display', 'none');
            $('#tab-two .JS_shop_type').val('1');
        }
        var shop_type = $('#tab-two .JS_shop_type').val();

        //插件模式
        var orderby = $('#tab-two .JS_development_version_option' + that.orderType + ' .JS_search_order_type').val();
        if (shop_type == 1) { // 淘宝、天猫
            orderby = $('#orderby_for_taobao_tmall').val();
        } else if (shop_type == 2) { // 1688
            orderby = $('#orderby_for_1688').val();
        }
        //重置分类
        var data_nick = $('#category_options').data('nick');
        if (data_nick != nick) {
            $(".js_category").html('');
            $("#category_options").html('');
            $(".js_category_options").html('');
        }

        var un_jsonp = $('#un_jsonp').val();
        var param = {
            shop_type: shop_type,
            nick: nick,
            keyword: keyword,
            is_onsale: onsale,
            category: category,
            category_name: category_name,
            lowPrice: low_price,
            highPrice: high_price,
            min_store: min_store,
            max_store: max_store,
            orderType: orderby,
            is_xinpin: (is_xinpin ? 1 : 0),
            development_version: development_version,
            page: page,
            fail_times: fail_times,
            alibaba_total_page: alibaba_total_page,
            alibaba_shop_id: alibaba_shop_id,
            alibaba_keyword: alibaba_keyword,
            un_jsonp: un_jsonp,
        };
        bigLoading();
        $('.JS_search_nick_error').addClass('hide');
        ajax('/copy_goods/ajaxGetShopGoods', param, function(data) {
            //模式选项条件切换
            $('.JS_development_version').hide();
            $('.script-show').hide();
            $('.auth-info').val(data.auth);
            $("[name='task_id']").val('');
            if (data.auth) {
                $('.auth-show').show();
                that.auth_content_init('open', data.auth);
            } else {
                $('.auth-show').hide();
                that.auth_content_init('close', 1, 2);
            }

            $('.JS_is_xinpin_auth').hide(); //接口，稳定模式，才显示

            if (data.shop_type == 1 || data.shop_type == 3) {
                that.showOptions(3); // taobao tmall
            } else if (data.shop_type == 2) { // 1688
                that.showOptions(4);
            }

            if (data.is_onsale == undefined && (data.development_version == '0' || data.development_version == '1') && !data.is_tmall) {
                $('.JS_is_xinpin_auth').css('display', 'inline-block'); //接口，稳定模式，才显示
            }
            if (data.is_tmall)
                $("[name='is_tmall']").val('1');
            else
                $("[name='is_tmall']").val('0');

            //view copy shop all info
            if (data.copy_shop_task_tips != undefined) {
                $('.JS_view_copy_all').show();
                $('.JS_view_copy_all_tips').attr('data-original-title', data.copy_shop_task_tips);
            } else $('.JS_view_copy_all').hide();

            if (data.status == 'OK') {
                if (!data.alibaba_end || data.alibaba_end == '2') {
                    var html = template('script-shop-goods-list', data);
                    $('#JS_shop_goods_list').html(html);
                }
                that.ajax_copyshop_list_tmp = {};
                $.each(that.copyshop_list, function(i, n) {
                    that.ajax_copyshop_list_tmp[i] = n;
                    $("#JS_shop_goods_list tr[data-num_iid='" + i + "'] .JS_copy_checkbox").parent().checkbox().checkbox('check');
                });
                $('#tab-two .JS_formlist').add(".formlist-top").removeClass('hide');


                $(".JS_page_copy_shop").html(data.pageinfo.pagenav);
                $(".JS_quicknav_copy_shop").html(data.pageinfo.qianniuQuickNav);
                $('.JS_list_error_copy_shop').addClass('hide');

                if (data.auth) {
                    $('.JS_formlist-top').show();
                    $('.JS_formlist-top .JS_onsale_type').closest('.select').show();
                    that.loadCatagory(nick);
                    $('#category_options').data('nick', nick);
                    $('.auth-show').show();
                    if (data.auth == '2')
                        $('.JS_formlist-top .JS_onsale_type').closest('.select').hide();
                } else {
                    $('.JS_formlist-top').hide();
                    $('.auth-show').hide();
                    $('.JS_formlist-top .JS_onsale_type').closest('.select').hide();
                }
                if (data.is_onsale && data.is_onsale != '1') {
                    $('.onsale-show').hide();
                    var order_type = $('.JS_search_order_type').val();
                    var orders = new Array("num", "modified", "delist_time");
                    if (orders.indexOf(order_type) == '-1') {
                        $('.JS_search_order_type').val('modified');
                        $('.JS_search_order_type').nextAll('span').html('最近修改时间');
                    }
                } else {
                    $('.onsale-show').show();
                }
                if (data.development_version == '3') {
                    $('.JS_formlist-top').show();
                    $('.JS_formlist-top .JS_onsale_type').closest('.select').hide();
                    $('#category_options').data('nick', nick);
                    $(".js_category").html(data.cat_list.list_content);
                    $("#category_options").html(data.cat_list.list_html);
                    $(".js_category_options").html(data.cat_list.list_html);
                    if (data.shop_type != '2') {
                        $('.script-show').show();
                    } else
                        $('.script-show').hide();
                } else {
                    $('.script-show').show();
                }

                if (data.is_tmall) { //天猫店铺分类显示
                    $('.JS_formlist-top').show();
                    $('.JS_formlist-top .JS_onsale_type').closest('.select').hide();
                    $('#category_options').data('nick', nick);
                }

                $('#tab-two .JS_search_category_click').hide();
                $('#tab-two .JS_formlist-top').removeAttr('style').css('display', 'inline-block');
                if (data.shop_type == '2') {
                    $('.JS_page_copy_shop>div').hide();
                    $("[name='alibaba_total_page']").val(data.alibaba_info.total_page);
                    $("[name='alibaba_shop_id']").val(data.alibaba_info.shop_id);
                    $("[name='alibaba_keyword']").val(data.alibaba_info.keyword);
                    $('.JS_formlist-top').show();
                    $('.JS_formlist-top .JS_onsale_type').closest('.select').hide();
                    $('#tab-two .JS_search_category_click').show();
                    $('#tab-two .JS_formlist-top').css({
                        'display': 'inline-block',
                        'float': 'right',
                        'margin-right': '400px'
                    });
                    if (data.alibaba_end == '1')
                        alert('没有商品了！');
                }

                if (!$('#tab-two .JS_category').val()) { //全店宝贝数量
                    $("[name='shopall_nums']").val(data.total);
                }

                $("[name='shop_id']").val(data.shop_id);
                $("#JS_shop_goods_list").removeClass('hide'); //显示列表
                $(".JS_copy_all").attr('data-total', data.total);


            } else if (data.status == 'timeout') { // 超时

                $("#JS_shop_goods_list").addClass('hide'); //隐藏列表
                showErrorNotice('该授权账号已过期，请刷新后重试！');

            } else if (data.status == 'REDIRECT') { // 重定向
                $('#tab-two .JS_formlist').add(".formlist-top").removeClass('hide');
                if (data.auth) {
                    $('.JS_formlist-top').show();
                    $('.JS_formlist-top .JS_onsale_type').closest('.select').show();
                    that.loadCatagory(nick);
                    $('#category_options').data('nick', nick);
                    $('.auth-show').show();
                    if (data.auth == '2')
                        $('.JS_formlist-top .JS_onsale_type').closest('.select').hide();
                } else {
                    $('.JS_formlist-top .JS_onsale_type').closest('.select').hide(); // 隐藏在售、仓库
                }
                if (data.shop_id != undefined) {
                    $("[name='shop_id']").val(data.shop_id);
                }
                if (data.task_id != undefined) {
                    $("[name='task_id']").val(data.task_id);
                }
                if (data.new_url == undefined) {
                    alert('缺少重定向URL！');
                } else {
                    $.ajax({
                        url: data.new_url,
                        dataType: 'jsonp',
                        jsonpCallback: "jQuery18205427866452373564_1506480083670", //自定义的jsonp回调函数名称，默认为jQuery自动生成的随机函数名
                        type: 'get',
                        timeout: 10000,
                        success: function(data) {

                        },
                        error: function(XMLHttpRequest, textStatus, errorThrown) {
                            // //部分用户无法成功使用 改用插件获取
                            closeBigLoading();
                            if (textStatus == "parsererror") {
                                $('#un_jsonp').val('1');
                                that.searchShopGoods(page);
                            } else if (textStatus == "timeout") { //超时
                                showErrorNotice('搜索店铺超时，请检查该店铺是否存在');
                            } else {
                                var msg = XMLHttpRequest.status + ' ' + textStatus + ' ' + errorThrown;
                                $.ajax({
                                    type: "POST",
                                    url: "/home/email_js_error",
                                    data: {
                                        msg: msg,
                                        xmlstatus: XMLHttpRequest.status,
                                        textstatus: textStatus,
                                        error: errorThrown,
                                    },
                                    contentType: "application/x-www-form-urlencoded; charset=utf-8",
                                    success: function(data) {

                                    }
                                })
                                showErrorNotice(XMLHttpRequest.status + ' ' + textStatus + ' ' + errorThrown);
                            }
                            // showErrorNotice('该授权账号已过期，请刷新后重试！');
                        }
                    });
                }
                return;
            } else {
                that.showItemListNoResults(data);
            }
            closeBigLoading();
        }, 'POST', {
            'show_loading': 1
        });
    };
    this.showOptions = function(type) {
        $('.JS_development_version_option0').hide();
        $('.JS_development_version_option2').hide();
        $('.JS_development_version_option3').hide();
        $('.JS_development_version_option4').hide();
        $('.JS_development_version_option' + type).show();
        that.orderType = type
    }

    // get copy shop goods params
    this.getShopGoodsParams = function(urls) {
        var params = that.getParams(urls, 2);
        return params;
    };

    //copy_list setInterval
    this.check_copy_list_status = function() {
        var arr_ids_created_at = $(".JS_copy_list tr[data-status='0']");
        var arr_var = [];
        arr_ids_created_at.each(function() {
            arr_var.push({
                log_id: $(this).attr('data-log_id')
            });
        });

        if (arr_var.length <= 0) return false;
        ajax("/copy_goods/ajaxGetCopyStatus", {
            id_created_ats: arr_var
        }, function(data) {
            if (data.status == 'OK' && data.list.complete) {
                if (data.limit) $('.show-limit-msg').show();
                else $('.show-limit-msg').hide();

                $.each(data.list.complete, function(i, n) {
                    var item = $(".JS_copy_list tr[data-log_id='" + n.log_id + "']");
                    var tds = item.find('td');
                    var tips, seller_nick;
                    if (n.shop_nick && tds.eq(4).find('div').length < 3)
                        seller_nick = '<div>' + n.shop_nick + '</div>';
                    else seller_nick = '';

                    if (n.status == '1') { //success
                        item.attr('data-status', '1');
                        tds.eq(2).html("<img src=\"" + n.img + "_80x80.jpg\" alt=\"\">");
                        var tip = '';
                        if (n.error_msg != '') {
                            tip = '<div><br><span class="color15"><i class="icon-infofill"></i>' + n.error_msg + '</span></div>';
                        }
                        tds.eq(3).html("<div><a href=\"https://item.taobao.com/item.htm?id=" + n.num_iid + "\" target=\"_blank\">" + n.title + "</a></div>");
                        tds.eq(3).append(tip);
                        if (seller_nick) tds.eq(4).append(seller_nick);
                        tds.eq(1).html('<div class="i-block posin Pull-down "><span class="i-block m-right-5 color-green">复制成功</span></div>');
                        tips = "<div><a class=\"new-btn m-btm-10\" href=\"https://item.taobao.com/item.htm?id=" + n.num_iid + "\" target=\"_blank\">查看宝贝</a></div>";
                        if (n.approve_status == 'instock') tips += "<div><a class=\"new-btn onsale-item m-btm-10\" data-num=\"" + n.num + "\" data-num_iid=\"" + n.num_iid + "\">上架宝贝</a></div>";
                        tips += '<div><a href="javascript:;" class="JS_delete_copy new-btn m-l-5">删除记录</a></div>';
                        tds.eq(5).html(tips);
                        showCopyNum();
                    } else if (n.status == '2') { //fail
                        item.attr('data-status', '2');
                        tds.eq(2).html("<img src=\"" + n.source_img + "_80x80.jpg\" alt=\"\">");
                        tds.eq(3).html('<div>' + n.source_title + '</div>');
                        var msg_title = n.change_error ? n.change_error : n.error_msg;
                        var tip = '';
                        if (msg_title)
                            tip = '<div><br><span class="color10"><i class="icon-infofill"></i>' + msg_title + '</span></div>';
                        tds.eq(3).append(tip);

                        if (seller_nick) tds.eq(4).append(seller_nick);
                        tds.eq(1).html('<div class="i-block posin Pull-down "><span class="i-block m-right-5 color10">复制失败</span></div>');
                        var pull_msg = '';
                        if (n.change_error) {
                            pull_msg += '<div class="i-block posin Pull-down tipsstyle2"><a class="JS_change_error m-btm-10 sui-btn btn-large btn-primary" href="javascript:;">重新复制</a><div class="sui-tooltip btn-tool confirm top in"><div class="tooltip-arrow" style="left:80%;"><div class="tooltip-arrow cover"></div></div><div class="tooltip-inner text-left">' + n.change_title + '</div></div></div>';
                        }
                        if (n.try_change == '1') {
                            pull_msg += '<a href="javascript:;" class="change_copy sui-btn btn-large btn-primary m-btm-10" data-is_copy_to_other="0">重新复制</a>';
                        } else if (n.try_again == '1') {
                            pull_msg += '<div class="i-block"><a href="javascript:;" class="JS_again_copy sui-btn btn-large btn-primary m-btm-10" data-is_copy_to_other="0">重新复制</a></div>';
                        } else if (n.try_other == '1') {
                            pull_msg += '<div class="i-block"><a href="' + n.url + '" class="sui-btn btn-large btn-primary m-btm-10" target="_blank">搜索同款</a></div>';
                        } else if (n.try_again_and_other == '1') {
                            pull_msg += '<div class="i-block"><a href="javascript:;" class="JS_again_copy sui-btn btn-large btn-primary m-btm-10" data-is_copy_to_other="0">重新复制</a></div>';
                            pull_msg += '<div class="i-block"><a href="' + n.url + '" class="sui-btn btn-large btn-primary m-btm-10" target="_blank">搜索同款</a></div>';
                        } else if (n.copy_to_other == '0') {
                            pull_msg += '<div class="i-block posin Pull-down tipsstyle2"><a class="JS_again_copy new-btn m-btm-10" href="javascript:;" data-is_copy_to_other="1">复制到其他</a><div class="sui-tooltip btn-tool confirm top in"><div class="tooltip-arrow"><div class="tooltip-arrow cover"></div></div><div class="tooltip-inner text-left">复制到其他类目可以最大程度保证复制到标题，主要属性，宝贝详情页等信息</div></div></div>';
                        }

                        pull_msg += '<br><a href="javascript:;" class="JS_delete_copy new-btn m-l-5">删除记录</a>';
                        tds.eq(5).html(pull_msg);
                    } else if (n.status == '0') { //ing
                        item.attr('data-status', '0');
                        tds.eq(1).html("复制中...");
                        tds.eq(2).html("");
                        tds.eq(5).html("");
                        if (!data.limit) {
                            tds.eq(3).html("");
                        } else {
                            tds.eq(3).html('<span class="color15">今天发布宝贝数量已到达上限，本任务将自动推迟到明天执行。</span>');
                        }
                    }
                });
                if (data.limit) {
                    $.each(data.list.process, function(i, n) {
                        var item = $(".JS_copy_list tr[data-log_id='" + n.log_id + "']");
                        var tds = item.find('td');
                        if (n.status == '0') { //ing
                            item.attr('data-status', '0');
                            tds.eq(1).html("复制中...");
                            if (!data.limit) {
                                tds.eq(2).html("正在复制...");
                                tds.eq(3).html("");
                                tds.eq(5).html("请稍后...");
                            } else {
                                tds.eq(2).html("");
                                tds.eq(5).html("");
                                tds.eq(3).html('<span class="color15">今天发布宝贝数量已到达上限，本任务将自动推迟到明天执行。</span>');
                            }
                        }
                    })
                }
                menuHover();
            }
            if (data.status == 'FAIL' || !data.list || data.list.process == undefined || data.list.process.length <= 0) {
                clearInterval(that.check_interval);
                that.check_interval = 0;
            }
        }, 'POST', {
            'show_loading': 1
        });

        if (!that.check_interval) {
            that.check_interval = self.setInterval(that.check_copy_list_status, 2000);
        }
    }

    // again copy
    this.againCopy = function(log_id, record_id, created_at, is_copy_to_other, page_again) {
        var item = $(".JS_copy_list tr[data-log_id='" + log_id + "']");
        if (item.length < 0) return;
        var tds = item.find('td');
        tds.eq(1).html("复制中...");
        tds.eq(2).html("");
        tds.eq(3).html("");
        tds.eq(5).html("");
        item.attr('data-status', '0');
        ajax("/copy_goods/ajaxAgainCopy", {
            log_id: log_id,
            record_id: record_id,
            created_at: created_at,
            is_copy_to_other: is_copy_to_other,
            page_again: page_again
        }, function(data) {
            if (data.status != 'OK') alert('请求失败。');
            else that.check_copy_list_status();
        });
    }

    // delete copy
    this.deleteCopy = function(log_id, record_id, created_at) {
        var item = $(".JS_copy_list tr[data-log_id='" + log_id + "']");
        if (item.length < 0) return;
        ajax("/copy_goods/ajaxDeleteCopy", {
            log_id: log_id,
            record_id: record_id,
            created_at: created_at
        }, function(data) {
            if (data.status == 'OK') {
                item.fadeOut('slow', function() {
                    $(this).remove();
                });
            } else that.dialog('fail', data.msg, '', '', '知道了', '', '删除失败');
        });
    };

    this.updateCopy = function(record_id, created_at) {
        var item = $(".JS_copy_list tr[data-record_id='" + record_id + "'][data-created_at='" + created_at + "']");
        if (item.length < 0) return;
        var tds = item.find('td');
        tds.eq(1).html("复制中...");
        tds.eq(2).html("");
        tds.eq(3).html("");
        tds.eq(5).html("");
        item.attr('data-status', '0');
        ajax("/copy_goods/ajaxUpdateCopy", {
            record_id: record_id,
            created_at: created_at
        }, function(data) {
            if (data.status != 'OK') alert('请求失败。');
        });
    }

    // dialog
    this.dialog = function(type, msg, fun_1, fun_2, btn_text1, btn_text2, title) {
        btn_text1 = btn_text1 == undefined ? '确定' : btn_text1;
        btn_text2 = btn_text2 == undefined ? '取消' : btn_text2;
        title = title == undefined ? '提示' : title;
        if (type == 'success') { //success
            $('#copySuccess .JS_btn1').off('click');
            $('#copySuccess .JS_btn2').off('click');
            $('#copySuccess #myModalLabel').html(title);
            $('#copySuccess .mol-right').html(msg);
            $('#copySuccess .JS_btn1').html(btn_text1);
            $('#copySuccess .JS_btn2').html(btn_text2);
            $('#copySuccess .JS_btn1').on('click', function() {
                if ('function' == typeof fun_1) fun_1();
            });
            $('#copySuccess .JS_btn2').on('click', function() {
                if ('function' == typeof fun_2) fun_2();
            });
            $('.JS_dialog_success').trigger('click');
        } else if (type == 'fail') { //fail
            $('#copySuccess .JS_btn1').off('click');
            $('#Replication #myModalLabel').html(title);
            $('#Replication .mol-right').html(msg);
            $('#Replication .JS_btn1').html(btn_text1);
            $('#Replication .JS_btn1').on('click', function() {
                if ('function' == typeof fun_1) fun_1();
            });
            $('.JS_dialog_fail').trigger('click');
        } else if (type == 'nobtn') { //success no btn
            $('#copyPrompt .JS_content').html(msg);
            $('.JS_dialog_nobtn').trigger('click');
        } else if (type == 'confirm') {
            $.confirm({
                body: [
                    '<div style="height: 100px;">',
                    '<table style="height: 100%;" border="0" cellpadding="0" cellspacing="0" width="100%">',
                    '<tbody>',
                    '<tr>',
                    '<td class="mol-left">',
                    '<div class="sui-msg msg-info" style="color:#f60">',
                    '<s class="msg-icon"></s>',
                    '</div>',
                    '</td>',
                    '<td class="mol-right">' + msg + '</td>',
                    '</tr>',
                    '</tbody>',
                    '</table>',
                    '</div>'
                ].join(''),
                okBtn: btn_text1,
                cancelBtn: btn_text2,
                okHidden: function(e) {
                    if ('function' == typeof fun_1) fun_1();
                },
                cancelHidden: function(e) {
                    if ('function' == typeof fun_2) fun_2();
                }
            });
        }
    };

    // address
    this.select_area = function(id, default_state, default_city, default_district) {
        var state_option = '';
        $.each(area_data, function(i, option) {
            if (i == 1) {
                default_state = option.n;
            }
            state_option += '<li role="presentation"><a role="menuitem" tabindex="-1" href="javascript:void(0);" value="' + option.n + '" did="' + i + '">' + option.n + '</a></li>';
        });
        $("#" + id + "_state").append(state_option);
        $("#" + id + "_state_input").val(default_state);
        $("#" + id + "_state_input").parent().find('span').html(default_state);

        var select_state = function() {
            var state = $("#" + id + "_state").find("li a[value='" + $("#" + id + "_state_input").val() + "']").attr('did');
            var source = area_data[state].s;
            var city_option = '';
            $.each(source, function(i, option) {
                if (i == 1) {
                    default_city = option.n;
                }
                city_option += '<li role="presentation"><a role="menuitem" tabindex="-1" href="javascript:void(0);" value="' + option.n + '" did="' + i + '">' + option.n + '</a></li>';
            });
            $("#" + id + "_city").html('');
            $("#" + id + "_city").append(city_option);

            $("#" + id + "_city_input").val(default_city);
            $("#" + id + "_city_input").parent().find('span').html(default_city);
        }

        $('body').on('change', "#" + id + "_state_input", select_state);
        if (default_state != undefined && $.trim(default_state) != '') {
            $("#" + id + "_state").val(default_state);
        }
        select_state();
        if (default_city != undefined && $.trim(default_city) != '') {
            $("#" + id + "_city").val(default_city);
        }
        if (default_district != undefined && $.trim(default_district) != '') {
            $("#" + id + "_district").val(default_district);
        }
    };

    this.setCopyContent = function(no) {
        var content = $.trim($('#copy_set_content_' + tab_type).html());
        if (!content) {
            content = $.trim($('#copy_set_content').html())
            $('#copy_set_content').html('')
        }
        var cat_content = $.trim($('#taobao_category_content_' + tab_type).html());
        if (!cat_content) {
            cat_content = $.trim($('#taobao_category_content').html())
            $('#taobao_category_content').html('')
        }

        var default_set = {
            'price_change': $(".JS_price_change").val(),
            'prefix': $('.prefix').val(),
            'suffix': $('.suffix').val(),
            'change_props_input': $('.change_props_input').val(),
            'list_time': $('.list_time').val(),
            'list_space': $('.list_space').val(),
            'asc_num': $('.asc_num').val(),
            'desc_num': $('.desc_num').val(),
        };

        var cat_set_vals = new Array;
        var cat_set_cids = new Array;
        $('.JS_cid').each(function() {
            if ($(this).prop('cid') && $(this).val()) {
                cat_set_vals.push($(this).val());
                cat_set_cids.push($(this).prop('cid'));
            }
        })

        $('#copy_set_content_' + tab_type).html('');
        $('#copy_set_content_' + no).html(content);
        $('#taobao_category_content_' + tab_type).html('');
        $('#taobao_category_content_' + no).html(cat_content);

        //input输出框中值在移动时丢失
        $(".JS_price_change").val(default_set.price_change);
        $('.prefix').val(default_set.prefix);
        $('.suffix').val(default_set.suffix);
        $('.change_props_input').val(default_set.change_props_input);
        $('.list_time').val(default_set.list_time);
        $('.list_space').val(default_set.list_space);
        $('.asc_num').val(default_set.asc_num);
        $('.desc_num').val(default_set.desc_num);
        //淘宝类目信息 在移动时显示丢失
        var i = 0;
        var input_cid;
        $.each(cat_set_vals, function(k, v) {
            input_cid = $('.JS_cid:eq(' + i + ')');
            input_cid.prop('cid', cat_set_cids[k]);
            input_cid.val(v);
            i++;
        })
        $('.combo-wrap').off('scroll').on('scroll', function() {
            $(this).find(".search_icon").css({
                top: $(this).scrollTop()
            })
        })

        $('#remove_temp_warning').tooltip();
        $('#change_props_warning').tooltip();
        $('#sync_relation_warning').tooltip();
        $('#code_warning').tooltip();
        $('#fault_tolerant_warning').tooltip();
        $('#shipping_warning').tooltip();
        $('#del_keys_warning').tooltip();
        $('#show_from_warning').tooltip();
        $('#fastcopy_warning').tooltip();
        tab_type = no

        // 重新初始化时间控件
        that.onsaleTime()
    }

    this.checkApiLimit = function() {
        ajax("/copy_goods/ajaxCheckApiLimit", {}, function(data) {
            if (data)
                $('.show-limit-msg').show();
            else
                $('.show-limit-msg').hide();
        })
    }

    this.loadCatagory = function(auth) {
        ajax("/copy_goods/ajax_load_category", {
            auth: auth
        }, function(data) {
            if (data.status == "OK") {
                $(".js_category").html(data.list_content);
                $("#category_options").html(data.list_html);
                $(".js_category_options").html(data.list_html);
            }
        }, 'POST', {
            'show_loading': 1
        });
    }

    this.auth_content_init = function(type, auth, order) {
        var auth = arguments[1] ? arguments[1] : 1;
        var order = arguments[2] ? arguments[2] : 1;
        if (type == 'open') {
            if (auth == '1')
                $('.msg-auth').removeClass('hide');
            $('.auth-content').removeClass('gray').addClass('black');
            $('.attr').removeAttr('readonly');
            $('.auth-content input').removeClass('disabled');
            $('.block-hide').addClass('hideNew');
            var options = '<li role="presentation"><a role="menuitem" tabindex="-1" href="javascript:void(0);" value="1">出售中</a></li><li role="presentation"><a role="menuitem" tabindex="-1" href="javascript:void(0);" value="2">仓库中</a></li>';
            $('#onsale_options').html(options);
            $('.auth-show').show();
        } else if (type == 'close') {
            $('.msg-auth').removeClass('hide').addClass('hide');
            $('.auth-content').addClass('gray').removeClass('black');
            $('.attr').attr('readonly', 'readonly');
            $('.auth-content input').removeClass('disabled').addClass('disabled');
            $('.block-hide').removeClass('hideNew');
            $('#onsale_options').html('');
            $('.JS_search_low_price').val('');
            $('.JS_search_high_price').val('');
            $('.JS_low_store').val('');
            $('.JS_high_store').val('');
            $('.onsale-show').show();
            $('.auth-show').hide();
            if (order == 1) {
                if ($('.JS_shop_type').val() != '2')
                    $('.JS_search_order_type').val('hotsell_desc');
                $('.JS_search_order_type').nextAll('span').html('总销量');
            }
        }
    }

    this.alertMsg = function(msg) {
        var width = 150;
        var height = 50;
        $.alert({
            backdrop: true, //决定是否为模态对话框添加一个背景遮罩层。另外，该属性指定static时，表示添加遮罩层，同时点击模态对话框的外部区域不会将其关闭。
            bgcolor: '#123456', //背景遮罩层颜色，默认是黑色。可以用rgba设置透明度
            keyboard: true, //是否可由esc按键关闭
            title: '',
            body: '<div style="display:table;width:100%;"><div class="text-center" style="display:table-cell;height:' + height + 'px;vertical-align:middle;">' + msg + '</div></div>', //必填
            //okBtn : '确认',
            //cancelBtn : '雅达',
            closeBtn: false, //是否显示右上角叉叉（html使用方式无需配置，直接改html结构即可）
            transition: false, //是否以transition动画方式显示隐藏对话框（html使用方式调用对话框时，也可直接删除.sui-modal元素上的类名fade即可）
            hasfoot: false, //是否显示脚部  默认true
            width: width, //{number|string(px)|'small'|'normal'|'large'}, //推荐优先使用后三个描述性字符串，统一样式
            height: height, //内容区（.modal-body）高度
            //remote: {string},  //如果提供了远程url地址，就会加载远端内容
            timeout: 2000, //单位毫秒ms ,对话框打开后多久自动关闭
            show: function() {
                $(this).find('.modal-header').remove();
                $(this).find('.modal-body').addClass('center').css('min-height', 'inherit');
            }
        })
    }

    this.getTaobaoCategory = function(parent_cid, level, cid) {
        var parent_cid = arguments[0] ? arguments[0] : 0;
        var level = arguments[1] ? arguments[1] : 0;
        var cid = arguments[2] ? arguments[2] : 0; //当前等级id 用于加载淘宝类目
        if (!cats_content[parent_cid]) {
            cats_content[parent_cid] = new Object;
            ajax("/copy_goods/get_taobao_category", {
                parent_cid: parent_cid
            }, function(data) {
                if (data.status == 'OK') {
                    cats_content[parent_cid] = data.cats;
                }
            }, 'POST', '', false)
        }
        if (!cats_content[parent_cid]) {
            alert('获取淘宝类目失败，请刷新后重试');
            return;
        }
        var cats = JSON.parse(cats_content[parent_cid]);

        var cats_div = '<div class="combo-select">';
        var placeholder = '复制源宝贝淘宝类目';
        cats_div += '<input class="input-text JS_cid" type="text" data-istype="true" cid="" readonly placeholder="' + placeholder + '"/>';
        cats_div += '<div class="combo-arrow"></div>';
        cats_div += '<div id="combo-scroll" class="combo-wrap combo-dropdown">';
        cats_div += '<div class="p-5 search_icon">';
        cats_div += '<input type="text" placeholder="';
        if (level == 0) cats_div += '请输入一级类目';
        cats_div += '" class="combo-input text-input">';
        cats_div += '</div>';
        cats_div += '<ul class="combo-ul">';
        if (level == 0) cats_div += '<li class="option-item option-cancel" value="">取消类目选择</li>';
        for (i in cats) {
            if (cats[i].status == 'normal')
                cats_div += '<li class="option-item" value="' + cats[i].cid + '" is_parent="' + cats[i].is_parent + '">' + cats[i].name + '</li>';
        }
        cats_div += '</ul>';
        cats_div += '<ul class="combo-search" style="display:none;">';
        cats_div += '</ul></div></div>';

        if (!cid) {
            $('.1688cats:gt(' + level + ')').remove();
            if (level > 0) {
                cats_div = '<div class="controls 1688cats">' + cats_div + '</div>';
                $('.1688cats:eq(' + level + ')').remove();
                $('.1688cats:last').after(cats_div);
            } else { //初始化
                $('.1688cats:eq(' + level + ')').html(cats_div);
                $(".category_tips").hide();
                var ev = $(".1688cats:eq(" + level + ") .JS_cid");
                //展开下拉列表
                $(".combo-select").removeClass("combo-open");
                ev.closest(".combo-select").addClass("combo-open");
                ev.siblings(".combo-wrap").find(".combo-input").val("");
                ev.siblings(".combo-wrap").find(".combo-ul").removeAttr("style");
                ev.siblings(".combo-wrap").find(".combo-search").css("display", "none").children("li").removeClass("option-hover");
            }
        } else {
            $('.1688cats:eq(' + level + ')').html(cats_div);
            //初始化 类目值
            var ev = $(".1688cats:eq(" + level + ") .JS_cid");
            var choose_val = $(".1688cats:eq(" + level + ") .combo-ul li[value='" + cid + "']");
            ev.prop('cid', cid);
            ev.val(choose_val.text());
            choose_val.addClass('option-hover');
            //展开下拉列表
            $(".combo-select").removeClass("combo-open");
            ev.closest(".combo-select").addClass("combo-open");
            ev.siblings(".combo-wrap").find(".combo-input").val("");
            ev.siblings(".combo-wrap").find(".combo-ul").removeAttr("style");
            ev.siblings(".combo-wrap").find(".combo-search").css("display", "none").children("li").removeClass("option-hover");
            //移动选中类目置合适位置

            if (choose_val.position() && $(".1688cats:eq(" + level + ") .combo-ul li:first").position()) {
                var top = choose_val.position().top;
                var first = $(".1688cats:eq(" + level + ") .combo-ul li:first").position().top;
                $('.1688cats:eq(' + level + ') #combo-scroll').scrollTop(top - first);
            }
        }

        $('.combo-wrap').off('scroll').on('scroll', function() {
            $(this).find(".search_icon").css({
                top: $(this).scrollTop()
            })
        })
    }

    this.searchInfo = function(the, val) {
        var cats_c = the.closest('.1688cats');
        var level_c = cats_c.index('.1688cats');
        var cid = 0;
        if (level_c)
            cid = cats_c.prev('.1688cats').find('.JS_cid').prop('cid');
        if (val) {
            the.closest("div").siblings(".combo-ul").hide().find("li").removeClass("option-hover");
            var values = JSON.parse(cats_content[cid]);
            var newArr = values.filter(function(item) {
                var text = $.trim(item.name).toLowerCase();
                var $this = $(this);
                /* Found */
                if (text.toString().indexOf(val) != -1) {
                    return true;
                }
            });

            var arr = '';
            if (newArr.length > 0) {
                for (i in newArr) {
                    arr += '<li class="option-item" value="' + newArr[i].cid + '" is_parent="' + newArr[i].is_parent + '">' + newArr[i].name + '</li>';
                }
                the.closest("div").siblings(".combo-search").html(arr);
            } else {
                the.closest("div").siblings(".combo-search").html('<li class="p-5">未找到结果，请输入正确<span class="color10">类目名称</span>搜索 </li>');
            }
            the.closest("div").siblings(".combo-search").show();
        } else {
            the.closest("div").siblings(".combo-ul").show();
            the.closest("div").siblings(".combo-search").html('');
            the.closest("div").siblings(".combo-search").hide();
        }
    }
}

function getClassName(obj, sName) {
    if (document.getElementsByClassName) {
        return obj.getElementsByClassName(sName);
    } else {
        var aTmp = obj.getElementsByTagName('*');
        var aRes = [];
        var arr = [];

        for (var i = 0; i < aTmp.length; i++) {
            arr = aTmp[i].className.split(' ');
            for (var j = 0; j < arr.length; j++) {
                if (arr[j] == sName) {
                    aRes.push(aTmp[i]);
                }
            }
        }
        return aRes;
    }
}

//----------下拉框滚动加载-------------
function bind_scroll() {
    var wrap = getClassName(document, "combo-wrap");
    for (var i = 0; i < wrap.length; i++) {
        wrap[i].onscroll = function() {
            var h = 0;
            $(this).children("*").each(function() {
                if ($(this).is(":visible")) {
                    h += $(this).outerHeight()
                }
            })
            $(".search_icon").css({
                top: $(this).scrollTop()
            })
            if (h <= $(this).scrollTop() + $(this).height() + $('#editing .search_icon').outerHeight()) {
                var input_text = $(this).closest('.combo-select').find('.input-text');
                var more = input_text.data('page_more');
                if (more) {
                    var cid = $('#editing .category_id').val();
                    var pid = input_text.data('pid');
                    var values = prop_values[cid][pid].values;
                    var page_no = input_text.data('page_no') + 1;
                    var num = 50;
                    var start = (page_no - 1) * num;
                    var end = page_no * num;
                    if (values && start < values.length) {
                        var array = values.slice(start, end);
                        var content = '';
                        for (j in array) {
                            content += '<li class="option-item" value="' + array[j].vid + '" is_parent="' + array[j].is_parent + '">' + array[j].name + '</li>';
                        }
                        $(this).find('.combo-ul').append(content);
                        input_text.data('page_no', page_no + 1);
                        if (values.length <= end) {
                            input_text.data('page_more', 'false');
                        }
                    } else {
                        input_text.data('page_more', 'false');
                    }
                }
            }
        }
    }
}

function assemble_content(content, i, cid) {
    var ii = 0;
    var html = '';
    var values;

    if (!prop_values[cid][content.pid]) {
        prop_values[cid][content.pid] = content;
        prop_name[content.pid] = i;
    }
    html += '<div class="list-attr">';
    html += '<div class="list-attr-title"><span>必填属性：</span></div>' + '<div class="control-group">' + '<label class="control-label"><b style="color: #f00;">*</b>' + i + '：</label>' + '<div class="controls">';
    html += '<div class="combo-select">';

    if (content.values) { //是否有下拉框
        data_istype = 'true';
    } else {
        data_istype = 'false';
    }

    html += '<input class="input-text" type="text" data-pid="' + content.pid + '" data-page_no="1" data-page_more="true"';
    if (content.is_input == 'true') { //是否可输入
        html += ' data-istype="' + data_istype + '" />';
    } else {
        html += ' data-istype="' + data_istype + '" readonly/>';
    }

    if (content.values) {
        html += '<div class="combo-arrow"></div>';
        values = content.values;
        html += '<div class="combo-wrap combo-dropdown">' + '<div class="p-5 search_icon"><input type="text" placeholder="" class="combo-input text-input"></div>';
        html += '<ul class="combo-ul">';
        for (j in values) {
            if (ii <= 50) {
                ii++;
                html += '<li class="option-item" value="' + values[j].vid + '" is_parent="' + values[j].is_parent + '">' + values[j].name + '</li>';
            } else {
                break;
            }
        }
        html += '</ul>';
        html += '<ul class="combo-search" style="display:none;"></ul>';
        html += '</div>';
    }
    html += '</div></div></div></div>';
    return html;
}

function showCopyNum() {
    ajax("/copy_goods/getCopyNumInfo", {}, function(data) {
        if (data) {
            $('.month_cost').html(data.total);
            $('.month_rest').html(data.rest);
            $('#rest_info').attr('data-original-title', data.rest_content);
            $('#rest_info').closest('a').show();
        }
    })
}

function tabActive() {
    var search = window.location.search;
    var ul = $('.JS_menu');
    if (search.indexOf('tap1') != -1) {
        ul.find('a[href="#tab-one"]').trigger('click');
    } else if (search.indexOf('tap2') != -1) {
        ul.find('a[href="#tab-five"]').trigger('click');
    } else if (search.indexOf('tap3') != -1) {
        ul.find('a[href="#tab-two"]').trigger('click');
    } else if (search.indexOf('tap4') != -1) {
        ul.find('a[href="#tab-three"]').trigger('click');
    } else if (search.indexOf('tap5') != -1) {
        ul.find('a[href="#tab-four"]').trigger('click');
    }
}

//继续搜索
$('body').on('click', '.continue_search_btn', function() {
    $('#dialog_input_check_code').modal('hide');

    var page = Number($('.JS_page_copy_shop').find('li.active a').text());
    var pages = Number($('.JS_page_copy_shop').find('.page-end').val());
    // var page = $(this).siblings('.page-num').val();
    // var pages = Number($(this).siblings('.page-end').val());
    if (page == '' || page == 0) page = 1;
    if (page > pages) page = pages;
    // $(this).siblings('.page-num').val(page);
    copy_goods.searchShopGoods(page);
})

// jsonp 请求 淘宝接口回调
function jQuery18205427866452373564_1506480083670(data) {
    shop_id = $("[name='shop_id']").val();
    shop_type = $("[name='shop_type']").val();
    shop_url = $("[name='shop_url']").val();
    task_id = $("[name='task_id']").val();

    if (data.rgv587_flag == 'sm') { //验证码
        var url = data.url;
        // 显示 dialog
        closeBigLoading(); // 关闭LOADING
        $('#dialog_input_check_code').modal('show');
        $('#checkcodepage').attr("src", data.url);

    } else { //从返回内容获取列表
        var list;
        //console.log(data);
        ajax("/copy_goods/ajax_parse_taobao_search_results", {
            shop_id: shop_id,
            shop_type: shop_type,
            task_id: task_id,
            content: data
        }, function(data) {
            if (data.status == 'OK') {
                copy_goods.showItemList(data);
            } else {
                copy_goods.showItemListNoResults(data);
            }
        })
    }
}